{
  "account.account": "الملف الشخصي والأمان",
  "account.accountDeleted": "تم حذف حسابك بنجاح.",
  "account.accountDescription": "الاسم، كلمة المرور، حذف الحساب",
  "account.accountSection": "الحساب",
  "account.changeEmail": "تغيير البريد الإلكتروني",
  "account.changePassword": "تغيير كلمة المرور",
  "account.currentPassword": "كلمة المرور الحالية",
  "account.dangerZone": "منطقة الخطر",
  "account.deleteAccount": "حذف حسابك",
  "account.deleteAccountConfirmation": "هل أنت متأكد من رغبتك في حذف حسابك؟ هذا الإجراء لا رجعة فيه.",
  "account.deleteAccountDescription": "هذا الإجراء يحذف حسابك وجميع معلوماتك. لا يوجد تراجع.",
  "account.emailChange": "تغيير عنوان البريد الإلكتروني",
  "account.emailChangeConfirmation": "تأكيد تغيير البريد الإلكتروني",
  "account.emailChangeFailure": "رابط تغيير البريد الإلكتروني غير صالح أو منتهي الصلاحية.",
  "account.emailChangeIntro": "أدخل عنوان بريدك الإلكتروني الجديد وكلمة المرور الحالية. سنرسل رابطًا إلى العنوان الجديد، ولن يتغير بريدك الإلكتروني إلا بعد فتحه.",
  "account.emailChangeSuccess": "تم تغيير بريدك الإلكتروني بنجاح إلى {newEmail}.",
  "account.emailChangeSuccessNoAddress": "تم تغيير عنوان بريدك الإلكتروني بنجاح.",
  "account.emailChangeVerificationSent": "تم إرسال بريد إلكتروني للتحقق إلى عنوان بريدك الإلكتروني الجديد. يرجى التحقق من صندوق الوارد والنقر على الرابط لتأكيد التغيير.",
  "account.manageAccount": "إدارة الحساب",
  "account.newEmailAddress": "عنوان البريد الإلكتروني الجديد",
  "account.newPassword": "كلمة المرور الجديدة",
  "account.newPasswordAgain": "كلمة المرور الجديدة مرة أخرى",
  "account.oldPassword": "كلمة المرور القديمة",
  "account.passwordChange": "تغيير كلمة المرور",
  "account.passwordChangeDescription": "حافظ على أمان حسابك",
  "account.passwordUpdated": "تم تحديث كلمة المرور بنجاح.",
  "account.profile": "الملف الشخصي",
  "account.profileUpdated": "تم تحديث الملف الشخصي بنجاح.",
  "account.signedInAs": "تم تسجيل الدخول باسم",
  "account.updateYourProfile": "تحديث ملفك الشخصي",
  "account.updateYourProfileDescription": "الاسم وتفضيلات العرض",
  "addons.accountOnHold": "انتهت صلاحية اتصال حسابك. يرجى إعادة الاتصال لاستئناف تحديثات البيانات.",
  "addons.accountOnHoldTitle": "الحساب معلق",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "أنشئ واحصل على مفتاح API الخاص بك من هذا الرابط",
  "addons.ambientWeatherDescription": "محطات Ambient Weather (WS-5000، WS-2000، WS-2902C،...)",
  "addons.apiKey": "مفتاح API",
  "addons.applicationKey": "مفتاح التطبيق",
  "addons.availableServices": "متاحة",
  "addons.cannotDisconnectLastAccount": "لا يمكن قطع الاتصال بطريقة تسجيل الدخول الوحيدة. يرجى إضافة طريقة تسجيل دخول أخرى أولاً.",
  "addons.connect": "اتصال",
  "addons.connected": "متصل",
  "addons.connectedAccounts": "الحسابات المتصلة",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedServices": "متصلة",
  "addons.connectedSince": "متصل منذ {date}",
  "addons.connectionSection": "الاتصال",
  "addons.connectionSuccess": "تم الاتصال بحساب {provider} بنجاح",
  "addons.davisApiSecret": "رمز API السري",
  "addons.davisApiV2Key": "مفتاح V2 API",
  "addons.davisDescription": "محطات Davis الجوية (Vantage Vue، Vantage Pro2،...)",
  "addons.davisRetrieveApiKey": "احصل على مفاتيح V2 API الخاصة بك من هذا الرابط",
  "addons.disconnect": "قطع الاتصال",
  "addons.disconnectConfirmation": "هل أنت متأكد من رغبتك في قطع الاتصال بحساب {provider} الخاص بك؟",
  "addons.disconnectionSuccess": "تم قطع الاتصال بحساب {provider} بنجاح",
  "addons.disconnectProviderDescription": "يوقف المزامنة. يتم الاحتفاظ بسجلك.",
  "addons.ecowittCreateAndRetrieveKeys": "أنشئ واحصل على مفتاح API ومفتاح التطبيق من هذا الرابط",
  "addons.ecowittDescription": "توفر Ecowitt محطات طقس احترافية بتقنية الواي فاي، ومقاييس حرارة لاسلكية داخلية وخارجية، وأجهزة مراقبة الرطوبة، ومقاييس أمطار عالية الدقة، وأجهزة مراقبة جودة الهواء والمزيد.",
  "addons.helpLink": "كيفية ربط {provider}",
  "addons.integrationsSection": "التكاملات",
  "addons.myAcuriteAccountOnHold": "تم تعليق حسابك. يرجى إدخال كلمة المرور لإعادة الاتصال بحسابك",
  "addons.myAcuriteDescription": "AcuRite هي العلامة التجارية الأولى لمحطات الطقس في أمريكا الشمالية. كشركة رائدة في تقنية الوقت والحرارة والطقس، توفر لك AcuRite معلومات تفصيلية عن بيئتك الداخلية والخارجية لتخطيط يومك بثقة.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "استخدم منظم الحرارة Netatmo لتغيير درجة حرارة منزلك، من سريرك أو من الجانب الآخر من العالم.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "محطة الطقس الشخصية في منزلك",
  "addons.notConnected": "غير متصل",
  "addons.or": "أو",
  "addons.providerAccountDisconnected": "انتهت صلاحية الاتصال بخدمة الطقس الخاصة بك. يرجى إعادة الاتصال لاستئناف تحديثات البيانات.",
  "addons.reconnect": "إعادة الاتصال",
  "addons.socialConnectionsIntro": "اربط حساباتك الاجتماعية لتمكين تسجيل الدخول السريع. يمكنك ربط الحسابات أو إلغاء ربطها في أي وقت.",
  "addons.weatherflowCreateToken": "أنشئ واحصل على الرمز المميز الخاص بك من هذا الرابط",
  "addons.weatherflowTempestDescription": "نظام Tempest للطقس مع مقياس رياح ومقياس أمطار مدمج",
  "addons.weatherServices": "خدمات الطقس",
  "addons.weatherServicesConnected": "{count, plural, =0 {لا توجد خدمات متصلة} one {# خدمة متصلة} two {# خدمتان متصلتان} few {# خدمات متصلة} many {# خدمة متصلة} other {# خدمة متصلة}}",
  "addons.weatherServicesDescription": "اربط Netatmo وDavis وWeatherflow والمزيد",
  "addons.wundergroundApiKey": "مفتاح API",
  "addons.wundergroundDescription": "Weather Underground هو مجتمع عالمي من الأشخاص الذين يربطون البيانات من أجهزة استشعار البيئة مثل محطات الطقس وأجهزة مراقبة جودة الهواء حتى نتمكن من توفير البيانات الغنية والمحلية التي تحتاجها لتحقيق شغفك",
  "addons.wundergroundRetrieveApiKey": "احصل على مفتاح API الخاص بك من هذا الرابط",
  "addons.wundergroundStationId": "معرف المحطة",
  "airQuality.adviceActivityGood": "يوم مثالي لممارسة النشاط في الخارج",
  "airQuality.adviceActivityHazardous": "تجنّب أي نشاط بدني في الخارج",
  "airQuality.adviceActivityLabel": "النشاط البدني",
  "airQuality.adviceActivityModerate": "يوم جيد لممارسة النشاط في الخارج",
  "airQuality.adviceActivitySensitive": "فكّر في جعل الأنشطة الخارجية أقصر وأقل شدة",
  "airQuality.adviceActivityUnhealthy": "قلّل الأنشطة الطويلة أو الشديدة وخذ فترات راحة أكثر",
  "airQuality.adviceActivityVeryUnhealthy": "تجنّب الأنشطة الطويلة أو الشديدة؛ فكّر في نقلها إلى الداخل",
  "airQuality.adviceGroupsGood": "لا حاجة إلى احتياطات خاصة",
  "airQuality.adviceGroupsHazardous": "ابقَ في الداخل وقلّل مستوى النشاط",
  "airQuality.adviceGroupsLabel": "الفئات الحساسة",
  "airQuality.adviceGroupsModerate": "الأشخاص الحساسون بشكل غير معتاد: أنشطة أقصر وأقل شدة",
  "airQuality.adviceGroupsSensitive": "اجعل الأنشطة الخارجية أقصر وأقل شدة، وخذ فترات راحة أكثر",
  "airQuality.adviceGroupsUnhealthy": "تجنّب الأنشطة الخارجية الطويلة أو الشديدة؛ وفكّر في نقلها إلى الداخل",
  "airQuality.adviceGroupsVeryUnhealthy": "تجنّب أي نشاط بدني في الخارج؛ أجّله أو انقله إلى الداخل",
  "airQuality.adviceTimingLabel": "أفضل وقت للخروج",
  "airQuality.adviceTimingMorning": "يُفضّل الصباح، فالأوزون أقل في ذلك الوقت",
  "airQuality.airQuality": "جودة الهواء",
  "airQuality.airQualityIndex": "مؤشر جودة الهواء",
  "airQuality.aqiForecast": "توقعات جودة الهواء",
  "airQuality.co2Fresh": "نقي",
  "airQuality.co2GettingStale": "خانق قليلاً",
  "airQuality.co2Stale": "خانق",
  "airQuality.dailyForecast": "التوقعات اليومية",
  "airQuality.dominantPollutant": "الملوث السائد",
  "airQuality.expectedPeak": "الذروة المتوقعة",
  "airQuality.good": "جيدة",
  "airQuality.goodDescription": "جودة الهواء مرضية، وتلوث الهواء يشكل خطراً ضئيلاً أو معدوماً",
  "airQuality.hazardous": "خطرة",
  "airQuality.hazardousDescription": "تنبيه صحي: قد يعاني أي شخص من آثار صحية أكثر خطورة",
  "airQuality.indoorAirQuality": "جودة الهواء الداخلي",
  "airQuality.moderate": "معتدلة",
  "airQuality.moderateDescription": "جودة الهواء مقبولة؛ ومع ذلك، بالنسبة لبعض الملوثات قد يكون هناك قلق صحي معتدل لعدد قليل جداً من الأشخاص الذين لديهم حساسية غير عادية لتلوث الهواء.",
  "airQuality.noForecastForLocation": "لا تتوفر توقعات لجودة الهواء في هذا الموقع.",
  "airQuality.now": "الآن",
  "airQuality.nowCastAqi": "مؤشر جودة الهواء NowCast",
  "airQuality.pollutants": "الملوثات",
  "airQuality.recommendations": "التوصيات",
  "airQuality.sensitiveUnhealthy": "غير صحية للفئات الحساسة",
  "airQuality.sensitiveUnhealthyDescription": "قد يعاني أفراد الفئات الحساسة من آثار صحية. من غير المرجح أن يتأثر عامة الناس.",
  "airQuality.subIndex": "المؤشر الفرعي لجودة الهواء",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "فهم المؤشر",
  "airQuality.unhealthy": "غير صحية",
  "airQuality.unhealthyDescription": "قد يبدأ الجميع في الشعور بآثار صحية؛ قد تعاني الفئات الحساسة من آثار صحية أكثر خطورة",
  "airQuality.veryUnhealthy": "غير صحية جداً",
  "airQuality.veryUnhealthyDescription": "تحذيرات صحية من حالات الطوارئ. من المرجح أن يتأثر جميع السكان.",
  "alerts.addAlert": "إضافة تنبيه",
  "alerts.addCondition": "إضافة شرط",
  "alerts.alertAdded": "تمت إضافة التنبيه بنجاح",
  "alerts.alertAuthorizationNotice": "تعمل التنبيهات فقط إذا سمحت لـ SmartMixin بعرض الإشعارات",
  "alerts.alertDeleted": "تم حذف التنبيه بنجاح",
  "alerts.alertName": "اسم التنبيه",
  "alerts.alertWhen": "أريد أن أتلقى تنبيهاً عندما:",
  "alerts.aqiGreaterThan": "مؤشر جودة الهواء أكبر من",
  "alerts.aqiGreaterThanThreshold": "مؤشر جودة الهواء أكبر من عتبة {value}{unit}",
  "alerts.aqiLessThan": "مؤشر جودة الهواء أقل من",
  "alerts.aqiLessThanThreshold": "مؤشر جودة الهواء أقل من عتبة {value}{unit}",
  "alerts.atLeastOneCondition": "تحتاج إلى إضافة شرط واحد على الأقل",
  "alerts.co2GreaterThan": "ثاني أكسيد الكربون أكبر من",
  "alerts.co2GreaterThanThreshold": "ثاني أكسيد الكربون أكبر من عتبة {value}{unit}",
  "alerts.co2LessThan": "ثاني أكسيد الكربون أقل من",
  "alerts.co2LessThanThreshold": "ثاني أكسيد الكربون أقل من عتبة {value}{unit}",
  "alerts.conditions": "الشروط",
  "alerts.conditionsDroppedOnStationChange": "غير مدعومة في هذه المحطة وتمت إزالتها: {conditions}",
  "alerts.createAlert": "إنشاء تنبيه",
  "alerts.dailyPrecipitationGreaterThan": "هطول الأمطار اليومي أكبر من",
  "alerts.dailyPrecipitationGreaterThanThreshold": "هطول الأمطار اليومي تجاوز عتبة {value}{unit}",
  "alerts.deleteAlert": "حذف التنبيه",
  "alerts.editAlert": "تعديل التنبيه",
  "alerts.editCondition": "تعديل الشرط",
  "alerts.gustSpeedGreaterThan": "سرعة الهبات أكبر من",
  "alerts.gustSpeedGreaterThanThreshold": "سرعة الهبات أكبر من عتبة {value}{unit}",
  "alerts.gustSpeedLessThan": "سرعة الهبات أقل من",
  "alerts.gustSpeedLessThanThreshold": "سرعة الهبات أقل من عتبة {value}{unit}",
  "alerts.heatIndexGreaterThan": "مؤشر الحرارة أكبر من",
  "alerts.heatIndexGreaterThanThreshold": "مؤشر الحرارة أكبر من عتبة {value}{unit}",
  "alerts.heatIndexLessThan": "مؤشر الحرارة أقل من",
  "alerts.heatIndexLessThanThreshold": "مؤشر الحرارة أقل من عتبة {value}{unit}",
  "alerts.humidexGreaterThan": "مؤشر الرطوبة أكبر من",
  "alerts.humidexGreaterThanThreshold": "مؤشر الرطوبة أكبر من عتبة {value}{unit}",
  "alerts.humidexLessThan": "مؤشر الرطوبة أقل من",
  "alerts.humidexLessThanThreshold": "مؤشر الرطوبة أقل من عتبة {value}{unit}",
  "alerts.humidityGreaterThan": "الرطوبة أكبر من",
  "alerts.humidityGreaterThanThreshold": "الرطوبة أكبر من عتبة {value}{unit}",
  "alerts.humidityLessThan": "الرطوبة أقل من",
  "alerts.humidityLessThanThreshold": "الرطوبة أقل من عتبة {value}{unit}",
  "alerts.inProgress": "قيد التنفيذ",
  "alerts.leafWetnessGreaterThan": "رطوبة الأوراق أكبر من",
  "alerts.leafWetnessGreaterThanThreshold": "رطوبة الأوراق أكبر من عتبة {value}{unit}",
  "alerts.leafWetnessLessThan": "رطوبة الأوراق أقل من",
  "alerts.leafWetnessLessThanThreshold": "رطوبة الأوراق أقل من عتبة {value}{unit}",
  "alerts.myAlerts": "تنبيهاتي",
  "alerts.noConfiguredAlert": "ليس لديك أي تنبيهات مُعدة بعد، ابدأ بإضافة واحد",
  "alerts.noiseGreaterThan": "الضوضاء أكبر من",
  "alerts.noiseGreaterThanThreshold": "الضوضاء أكبر من عتبة {value}{unit}",
  "alerts.noiseLessThan": "الضوضاء أقل من",
  "alerts.noiseLessThanThreshold": "الضوضاء أقل من عتبة {value}{unit}",
  "alerts.noteOnConditions": "ملاحظة: يتم تفعيل التنبيه عند تحقق جميع الشروط أدناه",
  "alerts.noTriggerHistory": "لم يتم تفعيل هذا التنبيه بعد.",
  "alerts.pm10GreaterThan": "PM 10 أكبر من",
  "alerts.pm10GreaterThanThreshold": "PM 10 أكبر من عتبة {value}{unit}",
  "alerts.pm10LessThan": "PM 10 أقل من",
  "alerts.pm10LessThanThreshold": "PM 10 أقل من عتبة {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 أكبر من",
  "alerts.pm1GreaterThanThreshold": "PM 1 أكبر من عتبة {value}{unit}",
  "alerts.pm1LessThan": "PM 1 أقل من",
  "alerts.pm1LessThanThreshold": "PM 1 أقل من عتبة {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 أكبر من",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 أكبر من عتبة {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 أقل من",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 أقل من عتبة {value}{unit}",
  "alerts.postStormSummary": "ملخص بعد العاصفة",
  "alerts.postStormSynopsisHelper": "ستتلقى إشعارًا ملخصًا بعد انتهاء كل عاصفة مطرية.",
  "alerts.postStormSynopsisSoleCondition": "لا يمكن دمج ملخص ما بعد العاصفة مع شروط أخرى.",
  "alerts.precipitationGreaterThan": "هطول الأمطار بالساعة أكبر من",
  "alerts.precipitationGreaterThanThreshold": "هطول الأمطار بالساعة تجاوز عتبة {value}{unit}",
  "alerts.pressureGreaterThan": "الضغط الجوي أكبر من",
  "alerts.pressureGreaterThanThreshold": "الضغط الجوي أكبر من عتبة {value}{unit}",
  "alerts.pressureLessThan": "الضغط الجوي أقل من",
  "alerts.pressureLessThanThreshold": "الضغط الجوي أقل من عتبة {value}{unit}",
  "alerts.rainRateGreaterThan": "معدل هطول المطر أكبر من",
  "alerts.rainRateGreaterThanThreshold": "معدل هطول المطر تجاوز عتبة {value}{unit}",
  "alerts.sensorNotReporting": "لا يرسل هذا المستشعر بيانات حاليًا. سيُستأنف التنبيه عندما يعود إلى الإرسال.",
  "alerts.soilMoistureGreaterThan": "رطوبة التربة أكبر من",
  "alerts.soilMoistureGreaterThanThreshold": "رطوبة التربة أكبر من عتبة {value}{unit}",
  "alerts.soilMoistureLessThan": "رطوبة التربة أقل من",
  "alerts.soilMoistureLessThanThreshold": "رطوبة التربة أقل من عتبة {value}{unit}",
  "alerts.solarRadiationGreaterThan": "الإشعاع الشمسي أكبر من",
  "alerts.solarRadiationGreaterThanThreshold": "الإشعاع الشمسي أكبر من عتبة {value}{unit}",
  "alerts.solarRadiationLessThan": "الإشعاع الشمسي أقل من",
  "alerts.solarRadiationLessThanThreshold": "الإشعاع الشمسي أقل من عتبة {value}{unit}",
  "alerts.stormChartUnavailable": "سجل الأمطار لهذه العاصفة غير متوفر.",
  "alerts.stormDetail": "ملخص العاصفة",
  "alerts.stormDuration": "المدة",
  "alerts.stormEnd": "النهاية",
  "alerts.stormPeakRate": "أقصى معدل هطول الأمطار",
  "alerts.stormStart": "البداية",
  "alerts.stormTotal": "إجمالي هطول الأمطار",
  "alerts.temperatureGreaterThan": "درجة الحرارة أكبر من",
  "alerts.temperatureGreaterThanThreshold": "درجة الحرارة أكبر من عتبة {value}{unit}",
  "alerts.temperatureLessThan": "درجة الحرارة أقل من",
  "alerts.temperatureLessThanThreshold": "درجة الحرارة أقل من عتبة {value}{unit}",
  "alerts.thresholdOutOfRange": "يجب أن تكون بين {min} و{max}",
  "alerts.thswGreaterThan": "THSW أكبر من",
  "alerts.thswGreaterThanThreshold": "THSW أكبر من عتبة {value}{unit}",
  "alerts.thswLessThan": "THSW أقل من",
  "alerts.thswLessThanThreshold": "THSW أقل من عتبة {value}{unit}",
  "alerts.thwGreaterThan": "THW أكبر من",
  "alerts.thwGreaterThanThreshold": "THW أكبر من عتبة {value}{unit}",
  "alerts.thwLessThan": "THW أقل من",
  "alerts.thwLessThanThreshold": "THW أقل من عتبة {value}{unit}",
  "alerts.triggerHistory": "سجل التنبيه",
  "alerts.uvGreaterThan": "مؤشر الأشعة فوق البنفسجية أكبر من",
  "alerts.uvGreaterThanThreshold": "مؤشر الأشعة فوق البنفسجية أكبر من عتبة {value}{unit}",
  "alerts.uvLessThan": "مؤشر الأشعة فوق البنفسجية أقل من",
  "alerts.uvLessThanThreshold": "مؤشر الأشعة فوق البنفسجية أقل من عتبة {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "الرؤية أكبر من عتبة {value}{unit}",
  "alerts.visibilityLessThanThreshold": "الرؤية أقل من عتبة {value}{unit}",
  "alerts.visiblityGreaterThan": "الرؤية أكبر من",
  "alerts.visiblityLessThan": "الرؤية أقل من",
  "alerts.whichMeasure": "ما القياس الذي تريد تلقي تنبيه بشأنه؟",
  "alerts.whichModule": "ما الوحدة التي تريد تلقي تنبيه بشأنها؟",
  "alerts.whichSensor": "ما المستشعر الذي تريد تلقي تنبيه بشأنه؟",
  "alerts.windChillGreaterThan": "برودة الرياح أكبر من",
  "alerts.windChillGreaterThanThreshold": "برودة الرياح أكبر من عتبة {value}{unit}",
  "alerts.windChillLessThan": "برودة الرياح أقل من",
  "alerts.windChillLessThanThreshold": "برودة الرياح أقل من عتبة {value}{unit}",
  "alerts.windSpeedGreaterThan": "سرعة الرياح أكبر من",
  "alerts.windSpeedGreaterThanThreshold": "سرعة الرياح أكبر من عتبة {value}{unit}",
  "alerts.windSpeedLessThan": "سرعة الرياح أقل من",
  "alerts.windSpeedLessThanThreshold": "سرعة الرياح أقل من عتبة {value}{unit}",
  "appUpdate.updateAvailable": "يتوفر تحديث",
  "appUpdate.updateAvailableOpenAppStore": "انقر لفتح App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "انقر لفتح Google Play",
  "appUpdate.updateAvailableVersion": "يتوفر تحديث: v{version}",
  "appUpdate.upgradeRequiredAndroid": "يلزم ترقية تطبيقك. قم بزيارة Google Play للترقية.",
  "appUpdate.upgradeRequiredIos": "يلزم ترقية تطبيقك. قم بزيارة App Store للترقية.",
  "astral.aboveHorizonAllDay": "فوق الأفق طوال اليوم",
  "astral.aboveTheHorizon": "فوق الأفق",
  "astral.apparentSize": "الحجم الظاهري",
  "astral.apparentSizeAcross": "{size} قطرًا",
  "astral.astronomicalDawn": "الفجر الفلكي",
  "astral.astronomicalDusk": "الشفق الفلكي",
  "astral.belowHorizonAllDay": "تحت الأفق طوال اليوم",
  "astral.belowHorizonSince": "تحت الأفق منذ {time}",
  "astral.belowHorizonSinceOn": "تحت الأفق منذ {day} {time}",
  "astral.brightAllNight": "سماء مضيئة طوال الليل — لا تعتم تمامًا",
  "astral.brightestMoment": "أكثر اللحظات إضاءة",
  "astral.civilDawn": "الفجر المدني",
  "astral.civilDusk": "الشفق المدني",
  "astral.darkSkyBetween": "سماء مظلمة من {from} إلى {to}",
  "astral.darkSkyWindow": "سماء مظلمة من {from} إلى {to} · {duration} بلا قمر",
  "astral.dayLength": "طول النهار",
  "astral.daylightThroughTheYear": "طول النهار خلال السنة",
  "astral.dayOfCycle": "اليوم {day} من أصل {total}",
  "astral.doesNotOccurToday": "لا يحدث اليوم",
  "astral.domeHint": "اسحب للتنقل عبر الليل",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "أبكر شروق",
  "astral.earliestSunset": "أبكر غروب",
  "astral.equinox": "الاعتدال",
  "astral.equinoxIn": "الاعتدال بعد {days, plural, zero {# يوم} one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "astral.evening": "المساء",
  "astral.exactPhaseAt": "التوقيت الدقيق {time}",
  "astral.firstQuarter": "الربع الأول",
  "astral.firstSunriseIn": "أول شروق بعد {days, plural, zero {# يوم} one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "astral.firstSunsetIn": "أول غروب بعد {days, plural, zero {# يوم} one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "astral.fullMoon": "البدر",
  "astral.goldenHourBegins": "بداية الساعة الذهبية",
  "astral.goldenHourEnds": "نهاية الساعة الذهبية",
  "astral.highestPoint": "أعلى نقطة",
  "astral.inDays": "بعد {days, plural, zero {# يوم} one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "astral.lastQuarter": "الربع الأخير",
  "astral.latestSunrise": "الشروق الأكثر تأخرًا",
  "astral.latestSunset": "الغروب الأكثر تأخرًا",
  "astral.litShort": "مضاء",
  "astral.longestDay": "أطول نهار",
  "astral.lowestPoint": "أدنى نقطة",
  "astral.maxAltitudeShort": "الأقصى",
  "astral.midday": "الظهيرة",
  "astral.midnightSun": "شمس منتصف الليل",
  "astral.midnightSunPeriod": "شمس منتصف الليل",
  "astral.milestoneFootnotePolar": "هنا لا تشرق الشمس ولا تغرب في {days, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}} من السنة، لذا تعرض القائمة متى يحدث ذلك بدلًا من أقصى مواعيد الشروق والغروب المعتادة.",
  "astral.milestoneFootnoteTemperate": "لا يقع أبكر غروب ولا آخر شروق في أقصر يوم — معادلة الزمن، لا الانقلاب الشمسي، هي التي تحدد هذين التاريخين.",
  "astral.moon": "القمر",
  "astral.moonAltitude": "الارتفاع",
  "astral.moonDirection": "السمت",
  "astral.moonDistance": "المسافة",
  "astral.moonlessFor": "{duration} بلا قمر",
  "astral.moonPhases": "أطوار القمر",
  "astral.moonrise": "شروق القمر",
  "astral.moonset": "غروب القمر",
  "astral.moonUpAllNight": "القمر فوق الأفق طوال الليل",
  "astral.moonWashesOutNight": "القمر فوق الأفق من {rise} إلى {set} ويضيء الليل كله",
  "astral.morning": "الصباح",
  "astral.nauticalDawn": "الفجر البحري",
  "astral.nauticalDusk": "الشفق البحري",
  "astral.newMoon": "المحاق",
  "astral.nextDay": "اليوم التالي",
  "astral.nextProperlyDarkNight": "الليلة المظلمة فعلًا التالية",
  "astral.nextRise": "شروق القمر التالي {time}",
  "astral.nextRiseOn": "شروق القمر التالي {day} {time}",
  "astral.nextSevenNights": "الليالي السبع القادمة",
  "astral.noAstronomicalDarknessTonight": "لا ظلام فلكيًا الليلة",
  "astral.noDarkNightAhead": "لا شيء خلال الأسبوعين القادمين",
  "astral.noSunriseToday": "لا شروق اليوم",
  "astral.nowAtBearing": "الآن ارتفاع {altitude} واتجاه {direction}",
  "astral.observing": "الرصد",
  "astral.ofDaylightLeft": "متبقية من ضوء النهار",
  "astral.overTheNextThreeWeeks": "خلال الأسابيع الثلاثة القادمة",
  "astral.percentLit": "مضاء بنسبة {percent}",
  "astral.polarNight": "ليل قطبي",
  "astral.polarNightPeriod": "ليل قطبي",
  "astral.rightNow": "الآن",
  "astral.riseShort": "شروق",
  "astral.setShort": "غروب",
  "astral.shortestDay": "أقصر نهار",
  "astral.solarNoon": "الظهر الشمسي",
  "astral.solstice": "الانقلاب",
  "astral.sunBelowHorizon": "الشمس {degrees}° تحت الأفق",
  "astral.sunEvents": "أحداث الشمس",
  "astral.sunNeverDarkEnough": "الشمس لا تنخفض أبدًا 18° تحت الأفق",
  "astral.sunNeverSets": "الشمس لا تغرب",
  "astral.sunrise": "شروق الشمس",
  "astral.sunriseAndSunset": "شروق وغروب الشمس",
  "astral.sunriseAt": "شروق الشمس في {time}",
  "astral.sunset": "غروب الشمس",
  "astral.sunsetAt": "غروب الشمس في {time}",
  "astral.thisYearAtNorth": "هذه السنة عند خط عرض {degrees}° شمالًا",
  "astral.thisYearAtSouth": "هذه السنة عند خط عرض {degrees}° جنوبًا",
  "astral.tonight": "الليلة",
  "astral.twilightAllNight": "شفق طوال الليل — لا تعتم تمامًا",
  "astral.upFor": "فوق الأفق لمدة {duration}",
  "astral.usableLight": "الضوء المفيد",
  "astral.vsAverage": "⁦{percent}⁩ مقارنة بالمتوسط",
  "astral.vsYesterday": "مقارنة بالأمس",
  "astral.waningCrescent": "الهلال المتناقص",
  "astral.waningGibbous": "الأحدب المتناقص",
  "astral.waxingCrescent": "الهلال المتزايد",
  "astral.waxingGibbous": "الأحدب المتزايد",
  "astral.whereToLook": "أين تنظر",
  "astral.withoutTheMoon": "{duration} بلا قمر",
  "auth.alreadyHaveAccount": "هل لديك حساب بالفعل؟",
  "auth.authContainerTagline": "لوحة الطقس الشخصية الخاصة بك. قم بتوصيل محطاتك واحصل على البيانات في الوقت الفعلي في متناول يدك.",
  "auth.backToLogin": "العودة إلى تسجيل الدخول",
  "auth.checkYourEmail": "تحقق من بريدك الإلكتروني",
  "auth.continueWithApple": "المتابعة مع Apple",
  "auth.continueWithFacebook": "المتابعة مع Facebook",
  "auth.continueWithGoogle": "المتابعة مع Google",
  "auth.email": "البريد الإلكتروني",
  "auth.emailRequiredLoginFacebook": "إذن البريد الإلكتروني مطلوب.",
  "auth.emailVerification": "التحقق من البريد الإلكتروني",
  "auth.emailVerificationFailure": "حدثت مشكلة في التحقق من بريدك الإلكتروني.",
  "auth.emailVerificationSuccess": "تم التحقق من بريدك الإلكتروني بنجاح.",
  "auth.firstName": "الاسم الأول",
  "auth.forgotPassword": "نسيت كلمة المرور؟",
  "auth.forgotPasswordSubtitle": "أدخل بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
  "auth.lastName": "اسم العائلة",
  "auth.login": "تسجيل الدخول",
  "auth.loginSubtitle": "مرحباً بعودتك! الرجاء إدخال بياناتك.",
  "auth.loginToSmartMixinDescription": "سجّل الدخول إلى SmartMixin للوصول إلى محطات الطقس الخاصة بك وعرض التحليلات وإدارة لوحة الطقس الشخصية.",
  "auth.logout": "تسجيل الخروج",
  "auth.logoutConfirmation": "هل تريد تسجيل الخروج؟",
  "auth.noAccountYet": "ليس لديك حساب بعد؟",
  "auth.or": "أو",
  "auth.password": "كلمة المرور",
  "auth.passwordReset": "إعادة تعيين كلمة المرور",
  "auth.passwordResetSuccess": "تم تحديث كلمة المرور بنجاح.",
  "auth.register": "إنشاء حساب",
  "auth.registerDescription": "أنشئ حساب SmartMixin مجاني لتوصيل محطاتك الجوية وتتبع بيانات الطقس والوصول إلى أدوات تحليل قوية.",
  "auth.registerSubtitle": "أنشئ حسابك للبدء.",
  "auth.restorePassword": "استعادة كلمة المرور",
  "auth.restorePasswordSuccess": "لقد أرسلنا لك رابط إعادة تعيين كلمة المرور على {emailAddress} مع مزيد من التعليمات.",
  "auth.sendReset": "إرسال تعليمات إعادة التعيين",
  "auth.signInWithApple": "تسجيل الدخول باستخدام Apple",
  "auth.socialAccount": "أو استخدم حسابك",
  "auth.staffVerificationCode": "رمز التحقق",
  "auth.staffVerificationExpiresIn": "تم التحقق. تنتهي الصلاحية بعد {duration}.",
  "auth.staffVerificationInvalidCode": "رمز غير صحيح. حاول مرة أخرى.",
  "auth.staffVerificationLoginAsStopped": "تم إيقاف Login As: أدخل رمز التحقق في شاشة Debug للمتابعة.",
  "auth.staffVerificationNotEnrolled": "لا يوجد تطبيق مصادقة مُعدّ لحسابك. أضف تطبيقًا من إعدادات الأمان في لوحة الإدارة.",
  "auth.staffVerificationPrompt": "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة، أو رمز استرداد، لاستخدام Login As والبحث عن المستخدمين.",
  "auth.staffVerificationSetupLink": "إضافة تطبيق مصادقة",
  "auth.staffVerificationSubmit": "تحقق",
  "auth.staffVerificationTitle": "تحقق الموظفين",
  "calendar.afternoon": "بعد الظهر",
  "calendar.april": "أبريل",
  "calendar.august": "أغسطس",
  "calendar.changePeriod": "الفترة: {period}. تغيير الفترة",
  "calendar.currentDay": "اليوم الحالي",
  "calendar.dateFormat": "تنسيق التاريخ",
  "calendar.day": "يوم",
  "calendar.december": "ديسمبر",
  "calendar.durationHours": "{hours} س",
  "calendar.durationHoursMinutes": "{hours} س {minutes} د",
  "calendar.durationMinutes": "{minutes} د",
  "calendar.durationMinutesSeconds": "{minutes} د {seconds} ث",
  "calendar.durationSeconds": "{seconds} ث",
  "calendar.endTime": "وقت الانتهاء",
  "calendar.evening": "مساء",
  "calendar.february": "فبراير",
  "calendar.goToNextDay": "اليوم التالي",
  "calendar.goToNextMonth": "الشهر التالي",
  "calendar.goToNextWeek": "الأسبوع التالي",
  "calendar.goToNextYear": "السنة التالية",
  "calendar.goToPreviousDay": "اليوم السابق",
  "calendar.goToPreviousMonth": "الشهر السابق",
  "calendar.goToPreviousWeek": "الأسبوع السابق",
  "calendar.goToPreviousYear": "السنة السابقة",
  "calendar.hour": "الساعة",
  "calendar.hoursCount": "{count, plural, zero {# ساعة} one {ساعة واحدة} two {ساعتان} few {# ساعات} many {# ساعة} other {# ساعة}}",
  "calendar.hoursShort": "س",
  "calendar.hoursShortCount": "{count, plural, zero {# س} one {# س} two {# س} few {# س} many {# س} other {# س}}",
  "calendar.january": "يناير",
  "calendar.july": "يوليو",
  "calendar.june": "يونيو",
  "calendar.last12Hours": "آخر 12 ساعة",
  "calendar.last24Hours": "آخر 24 ساعة",
  "calendar.last30Days": "آخر 30 يوماً",
  "calendar.last3Hours": "آخر 3 ساعات",
  "calendar.last6Hours": "آخر 6 ساعات",
  "calendar.last7Days": "آخر 7 أيام",
  "calendar.lastHour": "الساعة الأخيرة",
  "calendar.march": "مارس",
  "calendar.max": "الأقصى",
  "calendar.may": "مايو",
  "calendar.month": "شهر",
  "calendar.monthTotal": "إجمالي الشهر",
  "calendar.morning": "صباح",
  "calendar.nextHours": "الساعات القادمة",
  "calendar.night": "ليل",
  "calendar.november": "نوفمبر",
  "calendar.october": "أكتوبر",
  "calendar.oneDay": "يوم واحد",
  "calendar.oneHour": "ساعة واحدة",
  "calendar.oneMonth": "شهر واحد",
  "calendar.oneWeek": "أسبوع واحد",
  "calendar.periodRangeSpoken": "من {start} إلى {end}",
  "calendar.previous24Hours": "الـ 24 ساعة السابقة",
  "calendar.previous30Days": "الـ 30 يوماً السابقة",
  "calendar.previous7Days": "الـ 7 أيام السابقة",
  "calendar.previousDay": "اليوم السابق",
  "calendar.previousHours": "الساعات السابقة",
  "calendar.previousMonth": "الشهر السابق",
  "calendar.previousWeek": "الأسبوع السابق",
  "calendar.previousYear": "السنة السابقة",
  "calendar.sameDayLastYear": "نفس اليوم من العام الماضي",
  "calendar.sameMonthLastYear": "نفس الشهر من العام الماضي",
  "calendar.selectADate": "اختر تاريخاً",
  "calendar.selectAggregation": "اختر القيمة المعروضة",
  "calendar.selectAMonth": "اختر شهراً",
  "calendar.selectAYear": "اختر سنة",
  "calendar.selectGranularity": "اختر دقة الفترة الزمنية",
  "calendar.selectPeriod": "اختر فترة زمنية",
  "calendar.september": "سبتمبر",
  "calendar.sixHours": "6 ساعات",
  "calendar.startTime": "وقت البدء",
  "calendar.thirtyMinutes": "30 دقيقة",
  "calendar.threeHours": "3 ساعات",
  "calendar.timezone": "المنطقة الزمنية",
  "calendar.today": "اليوم",
  "calendar.untilChanged": "حتى التغيير",
  "calendar.untilTime": "حتى {time}",
  "calendar.untilTodayAt": "حتى اليوم الساعة {time}",
  "calendar.untilTomorrowAt": "حتى الغد الساعة {time}",
  "calendar.use24HourFormat": "استخدم تنسيق 24 ساعة",
  "calendar.week": "أسبوع",
  "calendar.year": "سنة",
  "calendar.yearToDate": "منذ بداية السنة",
  "calendar.yesterday": "أمس",
  "charts.averageOverThePeriod": "المتوسط خلال الفترة",
  "charts.calendarView": "عرض التقويم",
  "charts.charts": "الرسوم البيانية",
  "charts.chartView": "عرض الرسم البياني",
  "charts.comparison": "المقارنة",
  "charts.customizeComparisonMetrics": "تخصيص مقاييس المقارنة",
  "charts.customizeComparisonMetricsDescription": "اسحب العناصر لإعادة ترتيب مقاييس المقارنة. انقر على أيقونة العين لإظهار أو إخفاء المقاييس.",
  "charts.maxOverThePeriod": "الحد الأقصى خلال الفترة",
  "charts.measureToDisplay": "القياس المراد عرضه",
  "charts.minMaxRange": "أدنى / أقصى",
  "charts.noDataForThisPeriod": "لا توجد بيانات لهذه الفترة",
  "charts.observations": "الرصدات",
  "charts.observedTemperature": "درجة الحرارة المرصودة",
  "charts.showComparison": "عرض المقارنة",
  "charts.stationComparison": "مقارنة المحطات",
  "charts.stationComparisonDescription": "قارن بيانات الطقس التاريخية مع محطة أخرى",
  "charts.sumOverThePeriod": "المجموع التراكمي خلال الفترة",
  "charts.viewAsList": "قائمة",
  "charts.viewAsPeriods": "فترات",
  "common.add": "إضافة",
  "common.altitude": "الارتفاع",
  "common.analysis": "التحليل",
  "common.average": "المتوسط",
  "common.back": "رجوع",
  "common.backToHome": "العودة إلى الرئيسية",
  "common.cancel": "إلغاء",
  "common.cannotBeEmpty": "لا يمكن أن يكون هذا الحقل فارغاً.",
  "common.close": "إغلاق",
  "common.dailyForecast": "التوقعات اليومية",
  "common.default": "افتراضي",
  "common.delete": "حذف",
  "common.details": "التفاصيل",
  "common.edit": "تعديل",
  "common.exitFullscreen": "إنهاء ملء الشاشة",
  "common.forecast": "التوقعات",
  "common.frequency": "التردد",
  "common.full": "كامل",
  "common.fullscreen": "ملء الشاشة",
  "common.help": "مساعدة",
  "common.hidden": "مخفي",
  "common.high": "مرتفع",
  "common.iDontKnowYet": "لا أعرف بعد",
  "common.indoor": "داخلي",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "آخر تحديث",
  "common.low": "منخفض",
  "common.maximum": "الحد الأقصى",
  "common.medium": "متوسط",
  "common.minimum": "الحد الأدنى",
  "common.more": "المزيد",
  "common.moreInformation": "مزيد من المعلومات",
  "common.next": "التالي",
  "common.no": "لا",
  "common.noAccountNeeded": "لا حاجة لحساب",
  "common.noItemsAvailable": "لا توجد عناصر متاحة",
  "common.notNow": "ليس الآن",
  "common.now": "الآن",
  "common.openSettings": "فتح الإعدادات",
  "common.outdoor": "خارجي",
  "common.pageNotFound": "الصفحة غير موجودة",
  "common.pageNotFoundDescription": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
  "common.rain": "المطر",
  "common.share": "مشاركة",
  "common.shareImageFailed": "تعذّرت مشاركة الصورة",
  "common.shareYourWeather": "شارك طقسك",
  "common.skip": "تخطي",
  "common.start": "ابدأ",
  "common.unknown": "غير معروف",
  "common.validate": "تأكيد",
  "common.validEmail": "مطلوب عنوان بريد إلكتروني صالح.",
  "common.very_low": "منخفض جداً",
  "common.weatherObservations": "رصدات الطقس",
  "common.welcome": "مرحباً بك في SmartMixin!",
  "common.wind": "الرياح",
  "common.yes": "نعم",
  "common.zoomImage": "تكبير الصورة",
  "compass.E": "ق",
  "compass.E_long": "شرق",
  "compass.ENE": "ق ش ق",
  "compass.ENE_long": "شرق-شمال شرقي",
  "compass.ESE": "ق ج ق",
  "compass.ESE_long": "شرق-جنوب شرقي",
  "compass.N": "ش",
  "compass.N_long": "شمال",
  "compass.NE": "ش ق",
  "compass.NE_long": "شمال شرقي",
  "compass.NNE": "ش ش ق",
  "compass.NNE_long": "شمال-شمال شرقي",
  "compass.NNW": "ش ش غ",
  "compass.NNW_long": "شمال-شمال غربي",
  "compass.NW": "ش غ",
  "compass.NW_long": "شمال غربي",
  "compass.S": "ج",
  "compass.S_long": "جنوب",
  "compass.SE": "ج ق",
  "compass.SE_long": "جنوب شرقي",
  "compass.SSE": "ج ج ق",
  "compass.SSE_long": "جنوب-جنوب شرقي",
  "compass.SSW": "ج ج غ",
  "compass.SSW_long": "جنوب-جنوب غربي",
  "compass.SW": "ج غ",
  "compass.SW_long": "جنوب غربي",
  "compass.W": "غ",
  "compass.W_long": "غرب",
  "compass.WNW": "غ ش غ",
  "compass.WNW_long": "غرب-شمال غربي",
  "compass.WSW": "غ ج غ",
  "compass.WSW_long": "غرب-جنوب غربي",
  "dashboard.currentObservations": "الرصدات الحالية",
  "dashboard.currentRainEvent": "حدث المطر الحالي",
  "dashboard.currentWeatherConditions": "الأحوال الجوية الحالية",
  "dashboard.customizeDashboard": "تخصيص",
  "dashboard.customizeDashboardDescription": "اسحب العناصر لإعادة ترتيب لوحة المعلومات. انقر على أيقونة العين لإظهار أو إخفاء الأقسام.",
  "dashboard.dashboard": "لوحة التحكم",
  "dashboard.dayRangeExpected": "{value} متوقع في {time}",
  "dashboard.dayRangeReached": "{value} في {time}",
  "dashboard.dayRangeSteady": "ثابت عند {value} طوال اليوم",
  "dashboard.hiddenSensors": "أجهزة استشعار مخفية",
  "dashboard.lastRainEvent": "آخر حدث مطري",
  "dashboard.manageSensors": "إدارة أجهزة الاستشعار",
  "dashboard.manageSensorsDescription": "اسحب العناصر لإعادة ترتيب أجهزة الاستشعار. انقر على أيقونة العين لإظهار أو إخفاء أجهزة الاستشعار. انقر على الاسم لإعادة تسميته.",
  "dashboard.pressureSummary": "ملخص الضغط الجوي",
  "dashboard.rainEvents": "أحداث الأمطار",
  "dashboard.rainSummary": "ملخص الأمطار",
  "dashboard.shareOutdoorMeasures": "شارك قياساتك الخارجية",
  "dashboard.shareOutdoorMeasuresDescription": "شارك في مجتمع SmartMixin بجعل قياساتك الخارجية مرئية للآخرين. لن تتم مشاركة القياسات الداخلية أبداً.",
  "dashboard.temperatureSummary": "ملخص درجة الحرارة",
  "dashboard.windSummary": "ملخص الرياح",
  "devices.batteryLevel": "مستوى البطارية",
  "devices.firmwareVersion": "إصدار البرنامج الثابت",
  "devices.moduleCount": "{count, plural, zero {# وحدة} one {وحدة واحدة} two {وحدتان} few {# وحدات} many {# وحدة} other {# وحدة}}",
  "devices.moduleType": "نوع الوحدة",
  "devices.noNetatmoWeatherStationYet": "ليس لديك محطة Netatmo للطقس بعد.",
  "devices.noOutdoorModule": "لا توجد وحدة خارجية تعمل لهذه المحطة.",
  "devices.notReachable": "غير متصل",
  "devices.serialNumber": "الرقم التسلسلي",
  "devices.signalAverage": "متوسطة",
  "devices.signalBad": "ضعيفة",
  "devices.signalGood": "جيدة",
  "devices.signalStrength": "قوة الإشارة",
  "devices.signalUnknown": "غير معروفة",
  "devices.visitNetatmoWebsite": "زيارة موقع Netatmo",
  "devices.wifiStrength": "قوة الواي فاي",
  "forecastMaps.addColor": "إضافة لون",
  "forecastMaps.addLayer": "إضافة طبقة",
  "forecastMaps.autoPreview": "تلقائي",
  "forecastMaps.backToMaps": "العودة إلى الخرائط",
  "forecastMaps.build": "إنشاء",
  "forecastMaps.buildCompleted": "اكتمل الإنشاء",
  "forecastMaps.builderMetaDescription": "أنشئ خرائط توقعات مخصصة من طبقات نماذج الطقس.",
  "forecastMaps.builderTitle": "منشئ الخرائط",
  "forecastMaps.buildFailed": "فشل الإنشاء. يرجى المحاولة مرة أخرى.",
  "forecastMaps.buildNotPossible": "لا يمكن إنشاء هذه الخريطة بعد — لا توجد بيانات توقعات متاحة.",
  "forecastMaps.buildProgress": "جارٍ الرسم… {completed}/{total} خطوة",
  "forecastMaps.buildStarting": "جارٍ بدء الإنشاء…",
  "forecastMaps.byModel": "حسب النموذج",
  "forecastMaps.byZone": "حسب المنطقة",
  "forecastMaps.colormap": "تدرج الألوان",
  "forecastMaps.colormapCustom": "ألوان مخصصة",
  "forecastMaps.colormapGroupDomain": "إعدادات الطقس المسبقة",
  "forecastMaps.colormapGroupMatplotlib": "إعدادات علمية مسبقة",
  "forecastMaps.colorScale": "مقياس الألوان",
  "forecastMaps.contourLevels": "مستويات الكنتور",
  "forecastMaps.countryCanada": "كندا",
  "forecastMaps.countryFrance": "فرنسا",
  "forecastMaps.countryGermany": "ألمانيا",
  "forecastMaps.countryItaly": "إيطاليا",
  "forecastMaps.countryScandinavia": "إسكندنافيا",
  "forecastMaps.countrySpain": "إسبانيا",
  "forecastMaps.countrySwitzerland": "سويسرا",
  "forecastMaps.countryUnitedStates": "الولايات المتحدة",
  "forecastMaps.customColormapMinColors": "يتطلب تدرج الألوان المخصص لونين على الأقل",
  "forecastMaps.customExtent": "نطاق مخصص",
  "forecastMaps.displayName": "الاسم المعروض",
  "forecastMaps.downscaling": "معامل تخفيف أسهم الرياح",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "رسم المنطقة",
  "forecastMaps.east": "شرق",
  "forecastMaps.extentDrawHint": "اسحب على الخريطة لرسم المنطقة",
  "forecastMaps.extentInvalid": "يجب أن يكون الغرب أصغر من الشرق والجنوب أصغر من الشمال",
  "forecastMaps.height": "الارتفاع (بوصة)",
  "forecastMaps.hourOffset": "+{hour} س",
  "forecastMaps.invalidHexColor": "لون غير صالح — استخدم ‎#RRGGBB",
  "forecastMaps.layers": "الطبقات",
  "forecastMaps.layerTypeBarbs": "أسهم الرياح",
  "forecastMaps.layerTypeContour": "خطوط الكنتور",
  "forecastMaps.layerTypeFilledContour": "كنتور معبأ",
  "forecastMaps.layerTypeMagnitude": "المقدار",
  "forecastMaps.layerTypeRaster": "نقطي",
  "forecastMaps.layerTypeVectorField": "حقل متجهات",
  "forecastMaps.leave": "مغادرة",
  "forecastMaps.levelsCount": "العدد",
  "forecastMaps.levelsInvalid": "مستويات كنتور غير صالحة",
  "forecastMaps.levelsModeArange": "خطوة ثابتة",
  "forecastMaps.levelsModeExplicit": "قيم صريحة",
  "forecastMaps.levelsModeLinspace": "متباعدة بانتظام (العدد)",
  "forecastMaps.levelsStep": "الخطوة",
  "forecastMaps.levelsValues": "القيم",
  "forecastMaps.levelsValuesHint": "مفصولة بفواصل، تصاعديًا",
  "forecastMaps.localTimeHint": "يظهر بتوقيتك المحلي",
  "forecastMaps.mapDescription": "الوصف",
  "forecastMaps.mapName": "اسم الخريطة",
  "forecastMaps.mapNameRequired": "أدخل اسمًا",
  "forecastMaps.mapSettings": "إعدادات الخريطة",
  "forecastMaps.mapView": "خريطة تفاعلية",
  "forecastMaps.maxLayersReached": "وصلت هذه الخريطة إلى الحد الأقصى وهو {max} طبقات.",
  "forecastMaps.maxValue": "القيمة القصوى",
  "forecastMaps.memoryBudgetExceeded": "تتجاوز الدقة ميزانية الرسم — قلّل DPI أو الارتفاع",
  "forecastMaps.memoryBudgetUsage": "ميزانية الرسم: {percent}%",
  "forecastMaps.metaDescription": "خرائط توقعات متحركة مُنشأة من حسابات نماذج الطقس.",
  "forecastMaps.metric": "القياس",
  "forecastMaps.metricRequired": "اختر قياسًا",
  "forecastMaps.metricUnavailable": "غير متاح لهذا النموذج",
  "forecastMaps.minBelowMax": "يجب أن يكون الحد الأدنى أصغر من الحد الأقصى",
  "forecastMaps.minMaxRequired": "القيمتان الدنيا والقصوى مطلوبتان لهذا النوع من الطبقات",
  "forecastMaps.minValue": "القيمة الدنيا",
  "forecastMaps.modelNoRun": "لا يوجد تشغيل مكتمل بعد",
  "forecastMaps.moveLayerDown": "نقل لأسفل",
  "forecastMaps.moveLayerUp": "نقل لأعلى",
  "forecastMaps.myMaps": "خرائطي",
  "forecastMaps.nanClipToMin": "تقييد إلى الحد الأدنى",
  "forecastMaps.nanMask": "إخفاء",
  "forecastMaps.nanPolicy": "بيانات مفقودة",
  "forecastMaps.nanSkip": "تخطي",
  "forecastMaps.noCompletedRun": "لم يتم إنشاء هذه الخريطة بعد. يرجى التحقق مرة أخرى قريبًا.",
  "forecastMaps.noLayers": "لا توجد طبقات بعد. أضف طبقة للبدء.",
  "forecastMaps.noMapsAvailable": "لا توجد خرائط توقعات متاحة بعد.",
  "forecastMaps.north": "شمال",
  "forecastMaps.opacity": "العتامة",
  "forecastMaps.overlayLegend": "مفتاح الخريطة",
  "forecastMaps.pause": "إيقاف مؤقت",
  "forecastMaps.play": "تشغيل",
  "forecastMaps.pointValueError": "تعذر تحميل التوقعات لهذه النقطة.",
  "forecastMaps.pointValueLoading": "جارٍ تحميل التوقعات…",
  "forecastMaps.pointValueUnavailable": "لا توجد بيانات لهذا الوقت.",
  "forecastMaps.presets": "إعدادات مسبقة",
  "forecastMaps.preview": "معاينة",
  "forecastMaps.previewEmptyHint": "قم بإعداد طبقة صالحة واحدة على الأقل لرسم معاينة.",
  "forecastMaps.previewFailed": "فشلت المعاينة",
  "forecastMaps.previewHour": "ساعة التوقع",
  "forecastMaps.previewRendering": "جارٍ رسم المعاينة…",
  "forecastMaps.projection": "الإسقاط",
  "forecastMaps.projectionLambertConformal": "لامبرت المطابق",
  "forecastMaps.projectionMercator": "ميركاتور",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "مجسّم",
  "forecastMaps.regionEurope": "أوروبا",
  "forecastMaps.regionNorthAmerica": "أمريكا الشمالية",
  "forecastMaps.removeColor": "إزالة اللون",
  "forecastMaps.removeLayer": "إزالة الطبقة",
  "forecastMaps.retry": "إعادة المحاولة",
  "forecastMaps.run": "التشغيل: {run}",
  "forecastMaps.save": "حفظ",
  "forecastMaps.selectExtentOnMap": "تحديد المنطقة على الخريطة",
  "forecastMaps.south": "جنوب",
  "forecastMaps.title": "خرائط التوقعات",
  "forecastMaps.uMetric": "المركّبة U",
  "forecastMaps.unitConversion": "تحويل الوحدات",
  "forecastMaps.unitNone": "بدون",
  "forecastMaps.unsavedChangesBody": "لديك تغييرات غير محفوظة. هل تريد المغادرة وتجاهلها؟",
  "forecastMaps.unsavedChangesTitle": "تغييرات غير محفوظة",
  "forecastMaps.useCurrentView": "استخدام العرض الحالي",
  "forecastMaps.useModelDomain": "متوقف: يُستخدم نطاق النموذج بالكامل",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "يجب أن يختلف قياسا U وV",
  "forecastMaps.valueBetween": "يجب أن تكون بين {min} و{max}",
  "forecastMaps.variable": "المتغير",
  "forecastMaps.viewMap": "عرض الخريطة",
  "forecastMaps.vMetric": "المركّبة V",
  "forecastMaps.west": "غرب",
  "forecastMaps.windAnimation": "تحريك الرياح",
  "forecastModels.addForecastModel": "إضافة نموذج",
  "forecastModels.atYourStations": "متاحة في محطاتك",
  "forecastModels.coverageLoading": "جارٍ تحديد المحطات التي يغطيها كل نموذج…",
  "forecastModels.description_AROME": "نموذج عالي الدقة من Météo France يسمح بحل العواصف الحملية، يغطي أوروبا الغربية بدقة 1.3 كم. الأفضل في فئته للتنبؤات قصيرة المدى في فرنسا؛ يتم تحديثه كل ثلاث ساعات.",
  "forecastModels.description_ARPEGE_EU": "النطاق الأوروبي المتداخل لنموذج ARPEGE التابع لـ Météo France بدقة 10 كم. توقعات متوسطة المدى عبر أوروبا، يتم تحديثها أربع مرات يوميًا.",
  "forecastModels.description_ARPEGE_GLOBAL": "نموذج الطقس الرقمي العالمي لـ Météo France بدقة 25 كم، يصل حتى حوالي 4 أيام. يتم تحديثه أربع مرات يوميًا.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI من DMI: نموذج يسمح بحل العواصف الحملية فوق شمال غرب أوروبا — الدنمارك ودول البنيلوكس وأيرلندا والمملكة المتحدة والدول الاسكندنافية — بدقة 2 كم يصل إلى 60 ساعة، يُحدَّث ثماني مرات يوميًا. يحتوي على بيانات DMI المفتوحة المعدلة (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "نظام Global Deterministic Prediction System (نظام التنبؤ الحتمي العالمي) من Environment Canada: نموذج عالمي متوسط المدى بدقة 15 كم يصل إلى 10 أيام، يتم تحديثه مرتين يوميًا.",
  "forecastModels.description_EC_HRDPS": "نظام High Resolution Deterministic Prediction System (نظام التنبؤ الحتمي عالي الدقة) من Environment Canada: نموذج يسمح بحل العواصف الحملية فوق كندا وشمال الولايات المتحدة بدقة 2.5 كم يصل إلى 48 ساعة، يتم تحديثه أربع مرات يوميًا.",
  "forecastModels.description_EC_RDPS": "نظام Regional Deterministic Prediction System (نظام التنبؤ الحتمي الإقليمي) من Environment Canada: نموذج متوسط المدى لأمريكا الشمالية بدقة 10 كم، يتم تحديثه أربع مرات يوميًا.",
  "forecastModels.description_ECMWF_HRES": "النموذج عالي الدقة (IFS) للمركز الأوروبي للتنبؤات الجوية متوسطة المدى، ويُعد على نطاق واسع أفضل نظام تنبؤ عالمي في العالم. يغطي الكوكب بأكمله بدقة 25 كم حتى 15 يومًا، ويُحدَّث أربع مرات يوميًا. يحتوي على بيانات ECMWF المفتوحة المعدلة (CC BY 4.0).",
  "forecastModels.description_GFS": "النموذج العالمي الرئيسي متوسط ​​المدى من NOAA. يغطي الكوكب بأكمله بدقة 25 كم وحتى 16 يومًا، يتم تحديثه أربع مرات يوميًا.",
  "forecastModels.description_HRRR_CONUS": "نموذج High-Resolution Rapid Refresh من NOAA: نموذج يسمح بحل العواصف الحملية عبر الولايات المتحدة القارية بدقة 3 كم، يتم تحديثه كل ساعة. الأنسب للتنبؤات قصيرة المدى للعواصف الرعدية والطقس الشديد.",
  "forecastModels.description_ICON": "نموذج ICON العالمي من DWD بدقة 13 كم يغطي الكوكب بأكمله حتى 7.5 أيام، ويُحدَّث أربع مرات يوميًا. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I من ItaliaMeteo، يُشغَّل بالاشتراك مع ARPAE: نموذج يسمح بحل العواصف الحملية فوق إيطاليا بدقة 2.2 كم يصل إلى 72 ساعة، يُحدَّث مرتين يوميًا. يحتوي على بيانات ItaliaMeteo المفتوحة (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "التشغيل الضابط لنموذج ICON-CH1-EPS من MeteoSwiss: نموذج يسمح بحل العواصف الحملية فوق جبال الألب بدقة 1 كم يصل إلى 33 ساعة، يُحدَّث كل ثلاث ساعات.",
  "forecastModels.description_ICON_CH2": "التشغيل الضابط لنموذج ICON-CH2-EPS من MeteoSwiss: نموذج يسمح بحل العواصف الحملية فوق جبال الألب — سويسرا والمنطقة الألبية المحيطة — بدقة 2.1 كم يصل إلى 120 ساعة، يُحدَّث أربع مرات يوميًا.",
  "forecastModels.description_ICON_DE": "نموذج DWD عالي الدقة يسمح بحل العواصف الحملية عبر ألمانيا والدول المجاورة بدقة 2.2 كم. توقعات قصيرة المدى يتم تحديثها مرتين يوميًا. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "النطاق الأوروبي المتداخل لنموذج ICON التابع لـ DWD بدقة 7 كم يغطي أوروبا وشمال المحيط الأطلسي. توقعات متوسطة المدى يتم تحديثها أربع مرات يوميًا. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "خدمة التنبؤ بالطقس المفتوحة لمعهد الأرصاد الجوية النرويجي، تجمع بين النماذج الشمالية عالية الدقة وبيانات ECMWF لتقديم توقعات عالمية تصل إلى 10 أيام.",
  "forecastModels.description_MF_AROME_ANTILLES": "نطاق AROME المتداخل فوق جزر الأنتيل الفرنسية (غوادلوب، مارتينيك) بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "forecastModels.description_MF_AROME_GUYANE": "نطاق AROME المتداخل فوق غويانا الفرنسية بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "نطاق AROME المتداخل فوق كاليدونيا الجديدة بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "forecastModels.description_MF_AROME_POLYNESIE": "نطاق AROME المتداخل فوق بولينيزيا الفرنسية بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "نطاق AROME المتداخل فوق ريونيون ومايوت بدقة 2.5 كم. توقعات قصيرة المدى يتم تحديثها أربع مرات يوميًا.",
  "forecastModels.description_RRFS_CONUS": "نظام Rapid Refresh Forecast التابع لإدارة NOAA فوق الولايات المتحدة القارية بدقة 3 كم. تنبؤات كل ساعة تُحدَّث ثماني مرات يوميًا، تصل إلى 84 ساعة في الدورات الأربع الرئيسية و18 ساعة في الدورات الأخرى.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "نظام Rapid Refresh Forecast التابع لإدارة NOAA ويغطي أمريكا الشمالية بأكملها بدقة 13 كم. تنبؤات كل ساعة حتى 84 ساعة، تُحدَّث أربع مرات يوميًا.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "توقعات SmartMixin الرائدة. لكل ساعة في موقعك، نختار أفضل نموذج متاح — عادةً ما يكون نموذجًا إقليميًا عالي الدقة حيثما وجد (AROME في فرنسا، ICON-D2 في ألمانيا، HRRR في الولايات المتحدة، ARPEGE Europe عبر القارة…) ونعود إلى نموذج عالمي في أماكن أخرى — ثم نملأ أي فجوات من المصادر المجاورة. النتيجة هي توقعات واحدة سلسة تغطي أي مكان في العالم حتى 14 يومًا، يتم تحديثها تلقائيًا كلما تم تحديث أي من النماذج الأساسية.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "التوقعات العالمية المملوكة لـ Weatherflow التي تمزج نماذج عددية متعددة للطقس مع ملاحظات من شبكتها لمحطات الطقس Tempest. أفق تنبؤ عالمي مدته 10 أيام.",
  "forecastModels.everywhereElse": "في كل مكان آخر",
  "forecastModels.everywhereElseFoot": "يُستخدم في أي محطة لا تصل إليها نماذجك المفضّلة.",
  "forecastModels.everywhereElsePick": "اختر واحدًا",
  "forecastModels.fallbackBlend": "مزيج SmartMixin",
  "forecastModels.fallbackBlendSub": "يجمع بين عدة نماذج، كل واحد حيث يكون الأقوى.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES أينما وصل.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "النموذج العالمي من NOAA. ما تستخدمه جميع الحسابات اليوم.",
  "forecastModels.fallbackResolution": "أعلى دقة",
  "forecastModels.fallbackResolutionSub": "أدق شبكة متاحة في كل محطة.",
  "forecastModels.forecastChipLabelWithRun": "{model}، التشغيل {run}",
  "forecastModels.forecastChipRunHint": "اضغط مطولاً لإظهار آخر تشغيل أو إخفائه",
  "forecastModels.forecastComparisonDescription": "قارن بسهولة مخرجات نماذج التوقعات من عدة مصادر",
  "forecastModels.forecastFollowingPreferences": "وفقًا لتفضيلاتك",
  "forecastModels.forecastModel": "نموذج التوقعات",
  "forecastModels.forecastModelComparison": "مقارنة نماذج التوقعات",
  "forecastModels.forecastModelCoverage": "التغطية",
  "forecastModels.forecastModelDescription": "الوصف",
  "forecastModels.forecastModels": "نماذج التنبؤ",
  "forecastModels.forecastModelScopeGlobal": "عالمي",
  "forecastModels.forecastModelScopeGlobalDescription": "يغطي هذا النموذج الكوكب بأكمله.",
  "forecastModels.forecastModelScopeRegional": "إقليمي",
  "forecastModels.forecastModelScopeRegionalDescription": "يغطي هذا النموذج منطقة محددة فقط.",
  "forecastModels.forecastModelSpecifications": "المواصفات",
  "forecastModels.forecastNoPinLocation": "لا يصل أي نموذج مفضّل إلى هذا الموقع — يقرر «في كل مكان آخر».",
  "forecastModels.forecastNoPinStation": "لا يصل أي نموذج مفضّل إلى هذه المحطة — يقرر «في كل مكان آخر».",
  "forecastModels.forecastNoPreferredModels": "لم تُحدَّد نماذج مفضّلة بعد.",
  "forecastModels.forecastOverrideElsewhere": "تنطبق تفضيلاتك في كل مكان آخر.",
  "forecastModels.forecastPickForLocation": "أو اختر واحدًا لهذا الموقع",
  "forecastModels.forecastPickForStation": "أو اختر واحدًا لهذه المحطة",
  "forecastModels.forecastPinWinsLocation": "{model} — أول نموذج مفضّل لديك يصل إلى هذا الموقع.",
  "forecastModels.forecastPinWinsStation": "{model} — أول نموذج مفضّل لديك يصل إلى هذه المحطة.",
  "forecastModels.forecastServedNowHere": "حاليًا هنا هو {model}",
  "forecastModels.forecastSetForLocation": "مُعيَّن لهذا الموقع",
  "forecastModels.forecastSetForStation": "مُعيَّن لهذه المحطة",
  "forecastModels.forecastSettingsRowSub": "النماذج المفضّلة وما ينطبق في كل مكان آخر",
  "forecastModels.forecastStopUsingHere": "التوقف عن استخدامه هنا",
  "forecastModels.forecastUseForLocation": "استخدام {model} لهذا الموقع",
  "forecastModels.forecastUseForStation": "استخدام {model} لهذه المحطة",
  "forecastModels.forecastUsePreferred": "استخدام نماذجي المفضّلة",
  "forecastModels.frequencyHourly": "كل ساعة",
  "forecastModels.horizon": "أفق التنبؤ",
  "forecastModels.horizonValue": "حتى {value} ساعة",
  "forecastModels.meshSize": "حجم الشبكة",
  "forecastModels.pickerShowAll": "عرض الكتالوج الكامل",
  "forecastModels.pickerUnreachable": "{count, plural, zero {لا توجد نماذج أخرى لا تصل} one {نموذج واحد آخر لا يصل} two {نموذجان آخران لا يصلان} few {# نماذج أخرى لا تصل} many {# نموذجًا آخر لا يصل} other {# نموذج آخر لا يصل}} إلى أي من محطاتك",
  "forecastModels.pinInUse": "قيد الاستخدام",
  "forecastModels.pinShadowed": "لا يُستخدم أبدًا — يغطي نموذج أعلاه جميع محطاتك",
  "forecastModels.pinSlots": "{used} من {max} · اختر نموذجًا",
  "forecastModels.pinSlotsFull": "{max, plural, zero {جميع الخانات مستخدمة. أزل واحدة لإضافة أخرى.} one {الخانة الوحيدة مستخدمة. أزل نموذجها لإضافة آخر.} two {الخانتان مستخدمتان. أزل واحدة لإضافة أخرى.} few {جميع الخانات الـ# مستخدمة. أزل واحدة لإضافة أخرى.} many {جميع الخانات الـ# مستخدمة. أزل واحدة لإضافة أخرى.} other {جميع الخانات الـ# مستخدمة. أزل واحدة لإضافة أخرى.}}",
  "forecastModels.pinsUncoveredCount": "{used} من {count, plural, zero {محطاتك} one {محطتك} two {محطتيك} few {محطاتك الـ#} many {محطاتك الـ#} other {محطاتك الـ#}}: لا يصل إليها أي نموذج مفضّل — يقرر «في كل مكان آخر».",
  "forecastModels.pinsUncoveredNamed": "{stations}: {count, plural, zero {لا يصل إليها} one {لا يصل إليها} two {لا يصل إليهما} few {لا يصل إليها} many {لا يصل إليها} other {لا يصل إليها}} أي نموذج مفضّل — يقرر «في كل مكان آخر».",
  "forecastModels.pinUnreachable": "لا يُستخدم أبدًا — لا يصل إلى أي من محطاتك",
  "forecastModels.pinUsedAt": "يُستخدم في {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, zero {لا يُستخدم} one {يُستخدم في محطتك} two {يُستخدم في المحطتين} few {يُستخدم في المحطات الـ#} many {يُستخدم في المحطات الـ#} other {يُستخدم في المحطات الـ#}}",
  "forecastModels.pinUsedAtSome": "يُستخدم في {used} من {count, plural, zero {المحطات} one {محطة} two {محطتين} few {# محطات} many {# محطة} other {# محطة}}",
  "forecastModels.preferredModels": "النماذج المفضّلة",
  "forecastModels.preferredModelsAll": "قائمة واحدة، جميع المحطات",
  "forecastModels.preferredModelsOne": "قائمة واحدة، تنطبق في كل مكان",
  "forecastModels.publisher": "الناشر",
  "forecastModels.removePreferredModel": "إزالة {model} من نماذجك المفضّلة",
  "forecastModels.resetForecastPreference": "إعادة التعيين",
  "forecastModels.resetForecastPreferenceHint": "يمسح نماذجك المفضّلة ويعيد الإعداد الافتراضي لـ SmartMixin.",
  "forecastModels.servedNowMany": "الآن: GFS في {count, plural, zero {محطاتك} one {محطتك} two {محطتيك} few {محطاتك الـ#} many {محطاتك الـ#} other {محطاتك الـ#}}.",
  "forecastModels.servedNowNone": "الآن: GFS في كل مكان.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin متعدد النماذج",
  "forecastModels.title_WEATHERFLOW_FORECAST": "توقعات Weatherflow",
  "forecastModels.weatherForecastModels": "نماذج التوقعات الجوية",
  "helpCenter.articleCount": "{count, plural, zero {لا توجد مقالات} one {مقالة واحدة} two {مقالتان} few {# مقالات} many {# مقالة} other {# مقالة}}",
  "helpCenter.articleNotFound": "المقالة غير موجودة",
  "helpCenter.articleNotFoundDescription": "المقالة التي تبحث عنها غير موجودة.",
  "helpCenter.backToHelpCenter": "العودة إلى مركز المساعدة",
  "helpCenter.browseByCategory": "تصفح حسب الفئة",
  "helpCenter.categoryNotFound": "الفئة غير موجودة",
  "helpCenter.categoryNotFoundDescription": "هذه الفئة غير موجودة أو لا تحتوي على مقالات.",
  "helpCenter.contactSupport": "تواصل مع الدعم",
  "helpCenter.feedbackHelpsImprove": "تساعدنا ملاحظاتك على تحسين مقالات المساعدة.",
  "helpCenter.feedbackReasonNotAnswer": "لا يجيب على سؤالي",
  "helpCenter.feedbackReasonOutdated": "المعلومات قديمة",
  "helpCenter.feedbackReasonUnclear": "التعليمات غير واضحة",
  "helpCenter.feedbackWhatWentWrong": "ما هي المشكلة؟",
  "helpCenter.helpCategoryAccount": "الحساب",
  "helpCenter.helpCategoryBilling": "الفواتير",
  "helpCenter.helpCategoryForecast": "التوقعات",
  "helpCenter.helpCategoryGettingStarted": "البدء",
  "helpCenter.helpCategoryProviders": "مزودو الخدمة",
  "helpCenter.helpCategoryStations": "المحطات",
  "helpCenter.helpCategoryTroubleshooting": "استكشاف الأخطاء وإصلاحها",
  "helpCenter.helpCenter": "مركز المساعدة",
  "helpCenter.landingDescription": "ابحث عن إجابات للأسئلة الشائعة وتعلم كيفية الاستفادة القصوى من SmartMixin.",
  "helpCenter.linkToSection": "رابط إلى هذا القسم",
  "helpCenter.menuItemDescription": "الأسئلة الشائعة والأدلة",
  "helpCenter.minRead": "{minutes} دقيقة قراءة",
  "helpCenter.onThisPage": "في هذه الصفحة",
  "helpCenter.platformMobileApp": "تطبيق الجوال",
  "helpCenter.platformMobileOnly": "تطبيق الجوال فقط",
  "helpCenter.platformWebApp": "تطبيق الويب",
  "helpCenter.platformWebOnly": "تطبيق الويب فقط",
  "helpCenter.popularArticles": "المقالات الشائعة",
  "helpCenter.relatedArticles": "مقالات ذات صلة",
  "helpCenter.searchArticles": "البحث في المقالات...",
  "helpCenter.stillNeedHelp": "هل ما زلت بحاجة إلى مساعدة؟",
  "helpCenter.stillNeedHelpDescription": "إذا لم يجب هذا المقال على سؤالك، يسعدني مساعدتك مباشرة.",
  "helpCenter.supportEmailSubject": "مساعدة SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "مساعدة SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "شكراً لملاحظاتك!",
  "helpCenter.wasArticleHelpful": "هل كانت هذه المقالة مفيدة؟",
  "intro.locationDescription": "فعّل الوصول إلى الموقع للحصول على توقعات دقيقة مخصصة لمنطقتك بالضبط — لا مزيد من التوقعات العامة.",
  "intro.locationTitle": "توقعات مصممة لك",
  "intro.notificationDescription": "فعّل الإشعارات للحصول على تنبيهات في الوقت المناسب حول تغيرات الطقس التي تهمك — المطر أو الثلج أو الظروف الشديدة، في الوقت الذي تحتاج فيه إلى المعرفة.",
  "intro.notificationsTitle": "لا تفوّت أي تغير في الطقس",
  "intro.readyDescription": "استمتع بتوقعات دقيقة ورؤى الطقس في الوقت الفعلي وبيانات المحطات من جميع أنحاء العالم — كل ذلك في تطبيق واحد قوي.",
  "intro.readyTitle": "أنت جاهز!",
  "intro.welcomeDescription": "احصل على توقعات محلية فائقة الدقة مدعومة من أفضل الوكالات الجوية — بالإضافة إلى الوصول إلى أكثر من 40,000 محطة طقس في جميع أنحاء العالم لرؤية الأحوال الفعلية، الماضية والحاضرة.",
  "intro.welcomeTitle": "طقسك، بصورة جديدة",
  "landing.alsoAvailableOn": "متاح أيضاً على:",
  "landing.featureAlertsDescription": "عيّن حدودًا مخصصة لأي مقياس. احصل على إشعار عند انخفاض الحرارة أو بدء المطر أو اشتداد الرياح.",
  "landing.featureAlertsTitle": "تنبيهات ذكية",
  "landing.featureAnalyticsDescription": "رسوم بيانية تفاعلية وتحليل الاتجاهات وإحصائيات مفصلة. تعمق في بيانات الحرارة والرطوبة والضغط والأمطار والرياح.",
  "landing.featureAnalyticsTitle": "تحليلات متقدمة",
  "landing.featureExportDescription": "احصل على جميع بيانات الطقس الخاصة بك عبر البريد الإلكتروني في جدول بيانات Excel، جاهزة لمزيد من التحليل في Excel أو Google Sheets أو أدواتك المفضلة.",
  "landing.featureExportTitle": "تصدير بياناتك",
  "landing.featureForecastDescription": "الوصول إلى {count, plural, zero {#+ نموذج توقعات احترافي} one {#+ نموذج توقعات احترافي} two {#+ نموذجَي توقعات احترافيين} few {#+ نماذج توقعات احترافية} many {#+ نموذج توقعات احترافيًا} other {#+ نموذج توقعات احترافي}} بما في ذلك ECMWF وGFS والنماذج الإقليمية. قارنها جنبًا إلى جنب لتضع توقعاتك الخاصة.",
  "landing.featureForecastTitle": "مقارنة نماذج التوقعات",
  "landing.featureHistoryDescription": "الوصول إلى البيانات التاريخية بمقاييس ساعية ويومية وشهرية. صدّرها إلى Excel للبحث أو الأرشيفات الشخصية.",
  "landing.featureHistoryTitle": "سجل غني",
  "landing.featureMultiBrandDescription": "اربط Netatmo وDavis وTempest وEcowitt وAmbient Weather والمزيد. لا مزيد من التبديل بين التطبيقات.",
  "landing.featureMultiBrandTitle": "جميع العلامات التجارية، تطبيق واحد",
  "landing.featuresSubtitle": "SmartMixin يمنحك الأدوات لتحليل ومقارنة وفهم بيانات الطقس باحتراف.",
  "landing.featuresTitle": "مصمم لعشاق البيانات",
  "landing.finalCtaButton": "إنشاء حساب مجاني",
  "landing.finalCtaSubtitle": "انضم إلى آلاف المتحمسين للطقس الذين يثقون بـ SmartMixin.",
  "landing.finalCtaTitle": "هل أنت مستعد للتعمق أكثر في بيانات الطقس؟",
  "landing.heroCta": "ابدأ مجانًا",
  "landing.heroDescription": "تحليلات عميقة ورسوم بيانية جميلة وتوقعات احترافية — جميع محطاتك الجوية موحدة في تطبيق واحد قوي.",
  "landing.heroSecondaryCta": "استكشف الخريطة",
  "landing.heroTagline": "لعشاق الطقس",
  "landing.heroTitle": "شاهد طقسك كما لم تره من قبل",
  "landing.pricingFeatureAdvancedMetrics": "مقاييس متقدمة",
  "landing.pricingFeatureAlerts": "تنبيهات مخصصة",
  "landing.pricingFeatureExport": "تصدير البيانات (Excel)",
  "landing.pricingFeatureForecastComparison": "مقارنة التوقعات",
  "landing.pricingFeatureForecasts": "نماذج التنبؤ",
  "landing.pricingFeatureForecastsFreeTier": "نموذج واحد",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, zero {#+ نموذج} one {#+ نموذج} two {#+ نموذجين} few {#+ نماذج} many {#+ نموذجًا} other {#+ نموذج}}",
  "landing.pricingFeatureReports": "التحليلات والتقارير",
  "landing.pricingFeatureStationComparison": "مقارنة المحطات",
  "landing.pricingFeatureWidgets": "أدوات الشاشة الرئيسية",
  "landing.pricingFeatureYearOverYear": "تحليل سنة بسنة",
  "landing.pricingFreeCta": "ابدأ الآن",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "الأكثر شعبية",
  "landing.pricingPremiumCta": "ابدأ الآن",
  "landing.pricingPremiumDescription": "من 1.99 €/شهر — اشترك على الويب أو App Store أو Google Play",
  "landing.pricingSubtitle": "ابدأ مجانًا، وقم بالترقية عندما تحتاج المزيد.",
  "landing.pricingTitle": "أسعار بسيطة وشفافة",
  "landing.statBrands": "علامات تجارية مدعومة",
  "landing.statForecasts": "نماذج التنبؤ",
  "landing.statStations": "محطات الطقس",
  "landing.supportedDevicesNote": "بالإضافة إلى أكثر من {count, number} محطة عامة من شبكة المنظمة العالمية للأرصاد الجوية",
  "landing.supportedDevicesSubtitle": "اربط محطة الطقس الموجودة لديك في دقائق. ندعم {count, plural, zero {# علامة تجارية رئيسية} one {علامة تجارية رئيسية واحدة} two {علامتين تجاريتين رئيسيتين} few {# علامات تجارية رئيسية} many {# علامة تجارية رئيسية} other {# علامة تجارية رئيسية}} والعدد في ازدياد.",
  "landing.supportedDevicesTitle": "يعمل مع محطتك",
  "metrics.absolutePressure": "الضغط المطلق",
  "metrics.airDensity": "كثافة الهواء",
  "metrics.airGap": "الفجوة الهوائية",
  "metrics.apparentTemperature": "درجة الحرارة الظاهرية",
  "metrics.AQI": "مؤشر جودة الهواء",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "متوسط",
  "metrics.avg_wind": "متوسط الرياح",
  "metrics.beaufort": "بوفورت",
  "metrics.blackGlobeTemperature": "حرارة الكرة السوداء",
  "metrics.boilerOn": "المرجل يعمل",
  "metrics.boilerOnInHours": "المرجل يعمل (ساعات)",
  "metrics.co2": "ثاني أكسيد الكربون",
  "metrics.conductivity": "التوصيلية",
  "metrics.dailyPrecipitation": "هطول الأمطار اليومي",
  "metrics.dailyRain": "المطر اليومي",
  "metrics.degreeDayShort": "ي.د",
  "metrics.depth": "العمق",
  "metrics.depthSensors": "مستشعرات العمق",
  "metrics.dewPoint": "نقطة الندى",
  "metrics.distance": "المسافة",
  "metrics.downTrend": "هبوط",
  "metrics.ET": "التبخر-النتح",
  "metrics.etToday": "التبخر-النتح اليوم",
  "metrics.feelsLike": "الإحساس الحراري",
  "metrics.feelsLikeWithFormula": "الإحساس الحراري ({formula})",
  "metrics.frostPoint": "نقطة الصقيع",
  "metrics.gust": "هبة",
  "metrics.hail": "بَرَد",
  "metrics.heatIndex": "مؤشر الحرارة",
  "metrics.heatingDegreeDays": "أيام درجة التدفئة",
  "metrics.heatingPower": "قوة التدفئة",
  "metrics.humidex": "مؤشر الرطوبة",
  "metrics.humidity": "الرطوبة",
  "metrics.lastLightningImpact": "آخر صاعقة",
  "metrics.lastMeasure": "آخر قياس",
  "metrics.leafSensors": "مستشعرات الأوراق",
  "metrics.leafWetness": "رطوبة الأوراق",
  "metrics.lightningDistance": "المسافة",
  "metrics.lightningStrikeCount": "عدد ضربات البرق",
  "metrics.lightningStrikeDistance": "مسافة ضربة البرق",
  "metrics.max": "أقصى",
  "metrics.max_gust": "أقصى هبة",
  "metrics.maxToday": "أقصى اليوم",
  "metrics.min": "أدنى",
  "metrics.noise": "الضوضاء",
  "metrics.normalizedHeatingCoefficient": "معامل التدفئة المعياري",
  "metrics.outdoorTemperature": "درجة الحرارة الخارجية",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "الهطول",
  "metrics.pressure": "الضغط الجوي",
  "metrics.rain": "المطر",
  "metrics.rainDurationValue": "مدة المطر: {duration}",
  "metrics.rainfallMeasurement": "قياس هطول الأمطار",
  "metrics.rainRate": "معدل هطول المطر",
  "metrics.relativePressure": "الضغط النسبي",
  "metrics.setPoint": "نقطة الضبط",
  "metrics.snow": "ثلج",
  "metrics.snowfall": "تساقط الثلوج",
  "metrics.soilMoisture": "رطوبة التربة",
  "metrics.soilSensors": "مستشعرات التربة",
  "metrics.soilWaterTension": "شد ماء التربة",
  "metrics.solarEnergy": "الطاقة الشمسية",
  "metrics.solarRadiation": "الإشعاع الشمسي",
  "metrics.speed": "السرعة",
  "metrics.stableTrend": "مستقر",
  "metrics.sum": "المجموع",
  "metrics.temperature": "درجة الحرارة",
  "metrics.temperatureSensors": "مستشعرات الحرارة والرطوبة",
  "metrics.temperatureShort": "حرارة",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "صعود",
  "metrics.uv": "الأشعة فوق البنفسجية",
  "metrics.visibility": "الرؤية",
  "metrics.weatherCondition": "حالة الطقس",
  "metrics.wetBulbGlobeTemperature": "حرارة البصيلة الرطبة الكروية",
  "metrics.wetBulbTemperature": "حرارة البصيلة الرطبة",
  "metrics.wind": "الرياح",
  "metrics.windChill": "برودة الرياح",
  "metrics.windDirection": "اتجاه الرياح",
  "metrics.windMeasurement": "قياس الرياح",
  "metrics.windRun": "مسافة الرياح",
  "metrics.windRunDescription": "مسافة الرياح هي المسافة الإجمالية التي تقطعها الرياح خلال فترة زمنية",
  "metrics.windSpeed": "سرعة الرياح",
  "network.cancelError": "تم إلغاء الطلب",
  "network.connectionError": "الخادم غير متاح",
  "network.networkError": "الشبكة غير متاحة",
  "network.serverError": "حدث خطأ ما...",
  "network.timeoutError": "انتهت مهلة الاتصال",
  "network.unknownError": "خطأ غير معروف",
  "premium.alreadyPremium": "لديك حساب مميز بالفعل!",
  "premium.bestValue": "أفضل عرض",
  "premium.billingDetailsAndroid": "الفترة التجريبية المجانية: لن يتم تحصيل أي رسوم منك إذا ألغيت قبل 24 ساعة على الأقل من انتهاء الفترة التجريبية. بعد ذلك، يتجدد اشتراكك في SmartMixin تلقائيًا ما لم تلغه قبل 24 ساعة على الأقل من نهاية الفترة الحالية؛ ويمكنك الإلغاء في أي وقت من إعدادات حسابك في Google Play. يُحتسب كل تجديد بالسعر المعروض على الزر أعلاه. يتم تحصيل المبلغ من حسابك في Google Play عند تأكيد عملية الشراء وفي بداية كل فترة تجديد.",
  "premium.billingDetailsIos": "الفترة التجريبية المجانية: لن يتم تحصيل أي رسوم منك إذا ألغيت قبل 24 ساعة على الأقل من انتهاء الفترة التجريبية. بعد ذلك، يتجدد اشتراكك في SmartMixin تلقائيًا ما لم تلغه قبل 24 ساعة على الأقل من نهاية الفترة الحالية؛ ويمكنك الإلغاء في أي وقت من إعدادات حسابك في App Store. يُحتسب كل تجديد بالسعر المعروض على الزر أعلاه. يتم تحصيل المبلغ من حسابك في App Store عند تأكيد عملية الشراء وفي بداية كل فترة تجديد.",
  "premium.freeBannerBody": "تحصل الحسابات المجانية على GFS في كل مكان — تبدأ نماذجك المفضّلة و«في كل مكان آخر» بالعمل لحظة اشتراكك.",
  "premium.freeBannerTitle": "تُطبَّق التفضيلات مع Premium",
  "premium.freeSubscription": "اشتراك مميز مجاني",
  "premium.freeTrialForPeriod": "فترة تجريبية مجانية لمدة {period, plural, zero {# يوم} one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "premium.getUnlimitedAccess": "وصول غير محدود إلى:",
  "premium.manageMySubscription": "إدارة اشتراكي",
  "premium.notPurchasedYet": "لم يتم العثور على أي عملية شراء لـ SmartMixin Premium في حساب المتجر هذا.",
  "premium.orChooseMonthly": "أو اختر الشهري:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "نشط",
  "premium.premiumAnnualTrialInfo": "ابدأ بفترة تجريبية مجانية مدتها {days, plural, zero {# يوم} one {يوم واحد} two {يومان} few {# أيام} many {# يومًا} other {# يوم}}",
  "premium.premiumCurrentPlan": "الباقة الحالية",
  "premium.premiumDownloadApp": "نزّل التطبيق للاشتراك:",
  "premium.premiumEndsOn": "ينتهي في {date}",
  "premium.premiumFeatureAlerts": "تنبيهات الطقس",
  "premium.premiumFeatureAnalysis": "تحليل الطقس المتقدم",
  "premium.premiumFeatureCharts": "مقارنات الرسوم البيانية",
  "premium.premiumFeatureExport": "تصدير البيانات",
  "premium.premiumFeatureForecast": "نماذج التوقعات الإقليمية",
  "premium.premiumFeatureNotification": "أداة شريط الحالة",
  "premium.premiumFeatureTitle": "ميزة Premium",
  "premium.premiumFeatureWidgets": "أدوات الشاشة الرئيسية",
  "premium.premiumFreePlan": "مجاني",
  "premium.premiumInactive": "غير مشترك",
  "premium.premiumManageStoreSubscription": "اشتركت عبر {store}. يمكنك إدارة اشتراكك أو إلغاؤه هناك.",
  "premium.premiumManageWebSubscription": "إدارة اشتراكك، تحديث طريقة الدفع، أو الإلغاء.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "يتجدد في {date}",
  "premium.premiumSubscribeAnnual": "سنوي — 9,99 €/سنة",
  "premium.premiumSubscribedOn": "مُشترك عبر {platform}",
  "premium.premiumSubscribedOnWeb": "مُشترك عبر الويب",
  "premium.premiumSubscribeMonthly": "شهري — 1,99 €/شهر",
  "premium.premiumSubscribeOnWeb": "اشترك الآن لفتح جميع الميزات المميزة.",
  "premium.premiumSubscriptionSuccess": "تم تفعيل اشتراكك! استمتع بجميع الميزات المميزة.",
  "premium.premiumSubscriptionSuccessTitle": "مرحبًا في Premium!",
  "premium.premiumWebappNotice": "الاشتراك عبر الويب غير متاح حاليًا.",
  "premium.pricePerMonth": "{price}/شهر",
  "premium.pricePerYear": "{price}/سنة",
  "premium.purchasedNetatmoPro": "لقد اشتريت سابقاً Netatmo Pro ({date}). يمنحك هذا الوصول إلى مجموعة فرعية من الميزات المميزة. اشترك في أحد العروض التالية إذا كنت تريد الوصول إلى جميع الميزات المميزة.",
  "premium.purchaseFailed": "تعذّر إتمام عملية الشراء. يُرجى المحاولة مرة أخرى.",
  "premium.restoreFailed": "تعذّرت استعادة مشترياتك. يُرجى المحاولة مرة أخرى.",
  "premium.restorePurchase": "استعادة الشراء",
  "premium.savingsPercent": "وفر {percent}%",
  "premium.seePremium": "استعرض Premium",
  "premium.startFreeTrial": "ابدأ التجربة المجانية",
  "premium.storeUnavailable": "المتجر غير متاح حاليًا. يُرجى المحاولة لاحقًا.",
  "premium.subscribeNow": "اشترك الآن — بدون فترة تجريبية",
  "premium.switchToPremium": "التبديل إلى SmartMixin Premium",
  "premium.thenPrice": "ثم {price}",
  "providerHints.ambientWeatherApiKey": "تم إنشاؤه في إعدادات حسابك على ambientweather.net.",
  "providerHints.davisApiSecret": "يظهر مرة واحدة فقط عند إنشاء مفتاح V2 API — احتفظ به بأمان.",
  "providerHints.davisV2ApiKey": "من صفحة مفاتيح V2 API على weatherlink.com.",
  "providerHints.ecowittApi": "من صفحة API لحساب Ecowitt الخاص بك.",
  "providerHints.ecowittApp": "مفتاح التطبيق، أيضًا من حساب Ecowitt الخاص بك.",
  "providerHints.myAcuriteCredentialsBanner": "استخدم البريد الإلكتروني وكلمة المرور لحساب My AcuRite — وليس تسجيل دخول SmartMixin.",
  "providerHints.myAcuriteEmail": "البريد الإلكتروني لحساب My AcuRite الخاص بك — وليس تسجيل دخولك إلى SmartMixin.",
  "providerHints.myAcuritePassword": "كلمة مرور حساب My AcuRite الخاص بك.",
  "providerHints.weatherflowToken": "رمز للاستخدام الشخصي من tempestwx.com → الإعدادات → تفويضات البيانات.",
  "providerHints.wundergroundEditKey": "استخدم مفتاحًا آخر",
  "providerHints.wundergroundKey": "سلسلة طويلة من صفحة مفاتيح API الخاصة بحساب Weather Underground الخاص بك — وليس كلمة مرور wunderground.com.",
  "providerHints.wundergroundKeyExample": "مثال: 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "تم التحقق من مفتاح API",
  "providerHints.wundergroundNoStationsNearby": "لم يتم العثور على محطات بالقرب من هذا الموقع. حاول إدخال معرف محطة مباشرة.",
  "providerHints.wundergroundStationIdExample": "مثال: KCASANFR123",
  "providerIntro.ambientWeatherStep2": "احصل على مفتاح API الخاص بـ Ambient Weather.",
  "providerIntro.davisStep2": "احصل على مفتاح V2 API وسرّ API الخاص بـ Davis.",
  "providerIntro.ecowittStep2": "احصل على مفتاح API ومفتاح التطبيق Ecowitt.",
  "providerIntro.getStarted": "ابدأ الآن",
  "providerIntro.myAcuriteStep2": "استخدم البريد الإلكتروني وكلمة المرور لحسابك الحالي على My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "سجّل الدخول إلى Netatmo عند الطلب — لا حاجة لمفتاح API.",
  "providerIntro.netatmoWeatherStep2": "سجّل الدخول إلى Netatmo عند الطلب — لا حاجة لمفتاح API.",
  "providerIntro.signupBanner": "أوشكت — أنشئ حساب SmartMixin مجاني لربط {provider}.",
  "providerIntro.step1": "سجّل الدخول إلى حسابك في SmartMixin (وليس إلى {provider}).",
  "providerIntro.step3EmailPassword": "أدخلها هنا.",
  "providerIntro.step3KeyOrToken": "ألصقه هنا.",
  "providerIntro.step3OAuth": "اعتمد SmartMixin في النافذة المنبثقة.",
  "providerIntro.step3Wunderground": "الصق مفتاح API الخاص بك، ثم اختر محطة قريبة أو أدخل أي معرف محطة.",
  "providerIntro.title": "ربط {provider}",
  "providerIntro.weatherflowStep2": "احصل على رمز Tempest للاستخدام الشخصي.",
  "providerIntro.wundergroundBrowsePublic": "ليس لديك محطة؟ تصفح المحطات العامة",
  "providerIntro.wundergroundFindNearby": "ابحث عن محطات قريبة",
  "providerIntro.wundergroundOrEnterId": "أو أدخل معرف محطة",
  "providerIntro.wundergroundStep2": "احصل على مفتاح API الخاص بك من Weather Underground. بعد ذلك يمكنك ربط أي محطة — محطتك أو محطة عامة.",
  "reports.agroMeteorology": "الأرصاد الجوية الزراعية",
  "reports.analysis": "التحليل",
  "reports.annualCumulativeRainfallComparison": "مقارنة هطول الأمطار التراكمي السنوي",
  "reports.annualHeatingDurationComparison": "مقارنة مدة التدفئة السنوية",
  "reports.annualHeatingEfficiency": "كفاءة التدفئة السنوية",
  "reports.annualIndoorComparison": "مقارنة البيئة الداخلية السنوية",
  "reports.annualOutdoorComparison": "مقارنة البيئة الخارجية السنوية",
  "reports.annualOutdoorReport": "تقرير البيئة الخارجية السنوي",
  "reports.annualReport": "التقرير السنوي",
  "reports.annualSolarReport": "تقرير الطاقة الشمسية السنوي",
  "reports.annualWaterBalance": "ميزان المياه السنوي",
  "reports.annualWaterBalanceCarryOver": "ترحيل رصيد {year} ({value})",
  "reports.annualWaterBalanceDescription": "يساعد ميزان المياه (النسخة المبسطة، يُستخدم فقط المطر والتبخر-النتح) في إدارة إمدادات المياه",
  "reports.avgHumidity": "متوسط الرطوبة",
  "reports.avgMaxTemperature": "متوسط درجة الحرارة العظمى",
  "reports.avgMetric": "المتوسط – {metric}",
  "reports.avgMinTemperature": "متوسط درجة الحرارة الصغرى",
  "reports.avgPressure": "متوسط الضغط الجوي",
  "reports.avgTemperature": "متوسط درجة الحرارة",
  "reports.chartsAndTable": "الرسوم البيانية والجدول",
  "reports.climateNormalPeriodOfRecord": "فترة الرصد ({years, plural, zero {# سنة} one {سنة واحدة} two {سنتان} few {# سنوات} many {# سنة} other {# سنة}})",
  "reports.climateNormals": "المعدلات المناخية",
  "reports.climateNormalStandardLabel": "المعدل القياسي ({period})",
  "reports.climateTrendPerDecade": "اتجاه درجة الحرارة: ⁦{value}⁩ لكل عقد على مدى {years, plural, zero {# سنة} one {سنة واحدة} two {سنتان} few {# سنوات} many {# سنة} other {# سنة}}",
  "reports.coldestMonthRanking": "أبرد {month} في تاريخ الرصد",
  "reports.comfortable": "مريحة (45% {lessThan} الرطوبة ≤ 60%)",
  "reports.cumulativeRainfall": "هطول الأمطار التراكمي",
  "reports.cumulativeRainfallDescription": "تتبع إجمالي هطول الأمطار المتراكم خلال الفترة المحددة.",
  "reports.dailyMaxRainfall": "أقصى هطول يومي",
  "reports.dataExport": "تصدير البيانات",
  "reports.dataExportXlsxFormatDescription": "تصدير جميع بيانات محطتك بتنسيق Excel (*.xlsx). بمجرد النقر على الزر، ستتلقى بريداً إلكترونياً بالبيانات المعالجة بعد بضع دقائق.",
  "reports.daysOfData": "{days, plural, zero {# يوم} one {يوم واحد} two {يومان} few {# أيام} many {# يومًا} other {# يوم}} من البيانات",
  "reports.daysWithFrost": "أيام الصقيع",
  "reports.daysWithHeavyRain": "أيام الأمطار الغزيرة (≥ {threshold})",
  "reports.daysWithoutThaw": "أيام بدون ذوبان",
  "reports.daysWithStrongFrost": "أيام الصقيع الشديد",
  "reports.emailSent": "تم إرسال بريد إلكتروني إلى صندوق بريدك",
  "reports.frostDays": "أيام الصقيع",
  "reports.grasslandTemperatureSum": "مجموع درجة حرارة المراعي",
  "reports.grasslandTemperatureSumDescription": "إذا تم تجاوز مجموع {threshold} في الربيع، فقد تم الوصول إلى بداية النمو المستدام (يعمل في أوروبا)",
  "reports.growingDegreeDays": "أيام الدرجات المتراكمة",
  "reports.highPressure": "ضغط مرتفع (متوسط الضغط ≥ 1013 مليبار)",
  "reports.iceDays": "أيام التجمد",
  "reports.indoorReport": "تقرير البيئة الداخلية",
  "reports.keyFacts": "الحقائق الرئيسية",
  "reports.longestDrySpell": "أطول فترة جافة",
  "reports.longestRunOfRainyDays": "أطول فترة أيام ممطرة متتالية",
  "reports.longestRunWithoutRun": "أطول فترة بدون مطر",
  "reports.longestWetSpell": "أطول فترة ممطرة",
  "reports.lowPressure": "ضغط منخفض (متوسط الضغط {lessThan} 1013 مليبار)",
  "reports.maxHumidity": "الرطوبة القصوى",
  "reports.maxMetric": "الحد الأقصى – {metric}",
  "reports.maxPressure": "الضغط الأقصى",
  "reports.maxTemperature": "درجة الحرارة القصوى",
  "reports.maxTempGreaterThan": "درجة الحرارة العظمى ≥",
  "reports.maxTempMagnitude24h": "أقصى تغير (/24 ساعة)",
  "reports.minHumidity": "الرطوبة الدنيا",
  "reports.minMetric": "الحد الأدنى – {metric}",
  "reports.minPressure": "الضغط الأدنى",
  "reports.minTemperature": "درجة الحرارة الدنيا",
  "reports.minTempMagnitude24h": "أدنى تغير (/24 ساعة)",
  "reports.monthlyAverageCountdown": "{days, plural, zero {# يوم إضافي هذا الشهر} one {يوم واحد إضافي هذا الشهر} two {يومان إضافيان هذا الشهر} few {# أيام إضافية هذا الشهر} many {# يومًا إضافيًا هذا الشهر} other {# يوم إضافي هذا الشهر}}",
  "reports.monthlyAverageCountdownDetail": "عندئذٍ يظهر متوسط هذا الشهر وترتيبه.",
  "reports.monthlyAverageRule": "تظهر المتوسطات الشهرية والترتيب بمجرد أن يسجّل شهر تقويمي {days, plural, zero {# يوم} one {يومًا واحدًا} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}.",
  "reports.monthlyHeatingEfficiency": "كفاءة التدفئة الشهرية",
  "reports.monthlyOutdoorReport": "تقرير البيئة الخارجية الشهري",
  "reports.monthlyReport": "التقرير الشهري",
  "reports.monthlySolarReport": "تقرير الطاقة الشمسية الشهري",
  "reports.monthlyWindReport": "تقرير الرياح الشهري",
  "reports.monthsOfData": "{months, plural, zero {# شهر} one {شهر واحد} two {شهران} few {# أشهر} many {# شهرًا} other {# شهر}} من البيانات",
  "reports.numberOfDays": "عدد الأيام",
  "reports.outdoorReport": "تقرير البيئة الخارجية",
  "reports.overviewSection": "نظرة عامة",
  "reports.rainfall": "هطول الأمطار",
  "reports.rainyDays": "الأيام الممطرة",
  "reports.recordDailyRain": "أكثر الأيام مطراً",
  "reports.recordHigh": "أعلى درجة حرارة مسجّلة",
  "reports.recordLow": "أدنى درجة حرارة مسجّلة",
  "reports.recordsAndClimatology": "الأرقام القياسية والمناخ",
  "reports.recordsSince": "الأرقام القياسية منذ {date}",
  "reports.recordWindGust": "أقوى هبة رياح",
  "reports.relativelyWet": "رطبة نسبياً (60% {lessThan} الرطوبة ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, zero {لا توجد تقارير} one {تقرير واحد} two {تقريران} few {# تقارير} many {# تقريرًا} other {# تقرير}}",
  "reports.sendEmail": "إرسال بريد إلكتروني",
  "reports.summerDays": "الأيام الصيفية",
  "reports.tooDry": "جافة جداً (الرطوبة ≤ 45%)",
  "reports.tooWet": "رطبة جداً (الرطوبة {greaterThan} 80%)",
  "reports.tropicalNights": "الليالي الاستوائية",
  "reports.unlockPremiumSubtitle": "متضمّن في SmartMixin Premium",
  "reports.unlockPremiumTitle": "افتح {count, plural, zero {الميزات المميزة} one {ميزة مميزة واحدة} two {ميزتين مميزتين} few {# ميزات مميزة} many {# ميزة مميزة} other {# ميزة مميزة}}",
  "reports.warmestMonthRanking": "أحرّ {month} في تاريخ الرصد",
  "reports.waterBalance": "ميزان المياه",
  "reports.yearsOfData": "{years, plural, zero {# سنة} one {سنة واحدة} two {سنتان} few {# سنوات} many {# سنة} other {# سنة}} من البيانات",
  "reports.yearToDateTemperatureComparison": "مقارنة درجة الحرارة منذ بداية السنة",
  "sensors.bgtSensors": "الكرة السوداء و WBGT",
  "sensors.cameraFeed": "الكاميرا",
  "sensors.compareHumidity": "مقارنة الرطوبة",
  "sensors.compareMoisture": "مقارنة الرطوبة الأرضية",
  "sensors.comparePm25": "مقارنة PM2.5",
  "sensors.compareTemperatures": "مقارنة درجات الحرارة",
  "sensors.compareWaterTension": "مقارنة شد ماء التربة",
  "sensors.depthByChannel": "العمق حسب القناة",
  "sensors.heatStressExtreme": "إجهاد حراري بالغ",
  "sensors.heatStressModerate": "إجهاد حراري معتدل",
  "sensors.heatStressNone": "لا إجهاد حراري",
  "sensors.heatStressStrong": "إجهاد حراري شديد",
  "sensors.heatStressVeryStrong": "إجهاد حراري شديد جدًا",
  "sensors.indoorClimate": "المناخ الداخلي",
  "sensors.indoorCo2Levels": "مستويات CO2",
  "sensors.indoorTemperatureAndHumidity": "الحرارة والرطوبة",
  "sensors.leafWetnessByChannel": "رطوبة الأوراق حسب القناة",
  "sensors.lightningSensor": "البرق",
  "sensors.moistureByChannel": "الرطوبة الأرضية حسب القناة",
  "sensors.noDataAvailable": "لا تتوفر بيانات",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 و AQI",
  "sensors.pm25ByChannel": "PM2.5 حسب القناة",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "اختر القناة",
  "sensors.sensorDetailDescription": "عرض البيانات التاريخية والاتجاهات لقنوات المستشعرات.",
  "sensors.sensorHistory": "سجل المستشعر",
  "sensors.soilConductivityByChannel": "التوصيلية حسب القناة",
  "sensors.soilTemperatureByChannel": "حرارة التربة حسب القناة",
  "sensors.strikesToday": "الضربات اليوم",
  "sensors.temperatureByChannel": "الحرارة حسب القناة",
  "sensors.viewChart": "عرض الرسم البياني",
  "sensors.waterTensionByChannel": "شد ماء التربة حسب القناة",
  "settings.appearance": "المظهر",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "العربية",
  "settings.bulgarian": "البلغارية",
  "settings.catalan": "الكاتالانية",
  "settings.chartGestures": "الإيماءات على الرسوم البيانية",
  "settings.chartGesturesDescription": "السحب على الرسوم البيانية يغير الفترة الزمنية، والقرص يغير المقياس الزمني",
  "settings.choiceCount": "{count, plural, zero {# متاحة} one {# متاحة} two {# متاحة} few {# متاحة} many {# متاحة} other {# متاحة}}",
  "settings.contactUs": "اتصل بنا",
  "settings.contactUsDescription": "احصل على المساعدة أو أرسل ملاحظاتك",
  "settings.croatian": "الكرواتية",
  "settings.czech": "التشيكية",
  "settings.dailyDetailByPeriods": "التفاصيل اليومية حسب الفترات",
  "settings.dailyDetailByPeriodsDescription": "تجميع الساعات الـ24 في ليل وصباح وبعد الظهر ومساء — نفس التقسيم المستخدم في ملخص اليوم.",
  "settings.danish": "الدنماركية",
  "settings.dark": "المظهر الداكن",
  "settings.dataDisplay": "عرض البيانات",
  "settings.dateAndTime": "التاريخ والوقت",
  "settings.donateButton": "تبرّع",
  "settings.donateDescription": "تم بناء SmartMixin بواسطة فريق صغير. إذا وجدته مفيدًا، يمكنك دعم تطويره بتبرع لمرة واحدة بأي مبلغ. إنه هدية — فهو لا يغيّر باقتك ولا يفتح أي ميزات.",
  "settings.donateSuccessBody": "يساعد تبرعك في إبقاء SmartMixin يعمل ويتحسّن. نحن نقدّر ذلك حقًا.",
  "settings.donateSuccessTitle": "شكرًا لدعمك!",
  "settings.donateTitle": "ادعم SmartMixin",
  "settings.dragToReorder": "اسحب لإعادة الترتيب",
  "settings.dutch": "الهولندية",
  "settings.english": "الإنجليزية",
  "settings.french": "الفرنسية",
  "settings.german": "الألمانية",
  "settings.gestures": "الإيماءات",
  "settings.greek": "اليونانية",
  "settings.hungarian": "المجرية",
  "settings.italian": "الإيطالية",
  "settings.japanese": "اليابانية",
  "settings.korean": "الكورية",
  "settings.language": "اللغة",
  "settings.languageDescription": "اللغة المفضلة",
  "settings.light": "المظهر الفاتح",
  "settings.measurementUnits": "وحدات القياس",
  "settings.netatmoDashboard": "لوحة Netatmo",
  "settings.netatmoLayoutCards": "قائمة البطاقات",
  "settings.netatmoLayoutCardsDescription": "بطاقة لكل وحدة، في تمرير واحد",
  "settings.netatmoLayoutClassic": "الكلاسيكي",
  "settings.netatmoLayoutClassicDescription": "بطاقتان، مرّر بين الوحدات",
  "settings.netatmoNewLayoutNotice": "تخطيط جديد للوحة: بطاقة لكل وحدة.",
  "settings.netatmoSwitchBackToClassic": "العودة إلى الكلاسيكي",
  "settings.netatmoSwitchToLayout": "التبديل إلى {layout}",
  "settings.norwegian": "النرويجية",
  "settings.notificationsSection": "الإشعارات",
  "settings.ongoingNotificationEnabled": "تفعيل الإشعار الدائم",
  "settings.ongoingNotificationMetrics": "القياسات المعروضة",
  "settings.ongoingNotificationPermissionRequired": "إذن الإشعارات مطلوب",
  "settings.ongoingNotificationPreviewHint": "معاينة — فعّل الأداة لعرضها",
  "settings.ongoingNotificationStatusBar": "شريط الحالة",
  "settings.polish": "البولندية",
  "settings.portuguese": "البرتغالية",
  "settings.preferencesSection": "التفضيلات",
  "settings.privacyPolicy": "سياسة الخصوصية",
  "settings.russian": "الروسية",
  "settings.serbian": "الصربية",
  "settings.settings": "الإعدادات",
  "settings.settingsPageTitle": "الإعدادات - {page}",
  "settings.slovak": "السلوفاكية",
  "settings.smallDecimals": "أرقام عشرية صغيرة",
  "settings.smallDecimalsDescription": "عرض الأرقام العشرية بحجم أصغر",
  "settings.spanish": "الإسبانية",
  "settings.statusBarWidget": "أداة شريط الحالة",
  "settings.statusBarWidgetDescription": "بيانات الطقس مرئية دائمًا",
  "settings.subscriptionSection": "الاشتراك",
  "settings.supportSection": "الدعم",
  "settings.swedish": "السويدية",
  "settings.systemTheme": "مظهر النظام",
  "settings.termsOfService": "شروط الخدمة",
  "settings.turkish": "التركية",
  "settings.ukrainian": "الأوكرانية",
  "settings.units": "الوحدات",
  "settings.unitsDescription": "وحدات القياس المعروضة داخل التطبيق",
  "settings.update": "تحديث",
  "settings.windDirectionConvention": "سهم اتجاه الرياح",
  "settings.windDirectionConventionDescription": "اختر كيفية عرض أسهم اتجاه الرياح",
  "settings.windDirectionMeteorological": "اتجاه المصدر",
  "settings.windDirectionMeteorologicalDescription": "يشير السهم إلى مصدر الرياح (الاصطلاح الأرصادي)",
  "settings.windDirectionOceanographic": "اتجاه التدفق",
  "settings.windDirectionOceanographicDescription": "يشير السهم إلى وجهة الرياح (الاصطلاح المحيطي)",
  "stations.addAStation": "إضافة محطة",
  "stations.addToFavorites": "إضافة إلى المفضلة",
  "stations.addYourOwnStation": "أضف محطتك الخاصة",
  "stations.clearRecentLocations": "مسح الكل",
  "stations.clearSearch": "مسح البحث",
  "stations.currentLocation": "الموقع الحالي",
  "stations.customizedStationName": "اسم المحطة المخصص",
  "stations.favoriteLocations": "المفضلة",
  "stations.favoriteLocationsEmpty": "يمكنك إضافة ما يصل إلى 5 مواقع مفضلة.",
  "stations.favoriteStations": "المحطات المفضلة",
  "stations.filterStationDescription": "عدم عرض المحطات ذات القياسات غير الموثوقة",
  "stations.filterStations": "تصفية المحطات",
  "stations.filterStationSourceDescription": "اختر مزودي المحطات الذين تريد عرضهم على الخريطة",
  "stations.findStationsNearYou": "ابحث عن محطات قريبة منك",
  "stations.hiddenStations": "المحطات المخفية",
  "stations.hiddenStationsDescription": "يمكنك إظهار المحطة بالنقر على أيقونة العين بجانبها.",
  "stations.lastSeen": "آخر ظهور {time}",
  "stations.location": "الموقع",
  "stations.locationAddedToFavorites": "تمت إضافة الموقع إلى المفضلة",
  "stations.locationNotGranted": "لم يتم منح إذن الموقع. يرجى السماح بالوصول إلى موقعك في إعدادات الجهاز.",
  "stations.locationRemovedFromFavorites": "تمت إزالة الموقع من المفضلة",
  "stations.locations": "المواقع",
  "stations.locationUnavailable": "تعذّر تحديد موقعك. يرجى التحقق من إعدادات جهازك.",
  "stations.maxFavoriteLocationsReached": "يمكنك الاحتفاظ بـ 5 مواقع مفضلة فقط. احذف واحداً لإضافة آخر.",
  "stations.modifyFavoriteStations": "تعديل المحطات المفضلة",
  "stations.modifyFavoriteStationsDescription": "يمكنك إعادة ترتيب محطاتك المفضلة بسحبها. يمكنك أيضاً إزالتها من القائمة.",
  "stations.myLocation": "موقعي",
  "stations.nearbyWeatherStations": "محطات الطقس القريبة",
  "stations.noLocationsFound": "لم يتم العثور على مواقع",
  "stations.noSearchResults": "لا توجد مقالات مطابقة لبحثك",
  "stations.noStationsFound": "لم يتم العثور على محطات",
  "stations.noWeatherStationYet": "ليس لديك محطة طقس بعد.",
  "stations.recentLocations": "الأخيرة",
  "stations.recentLocationsEmpty": "سجل المواقع الأخيرة فارغ.",
  "stations.removeFromFavorites": "إزالة من المفضلة",
  "stations.searchForLocation": "البحث عن موقع",
  "stations.searchForWeatherStation": "البحث عن محطة طقس",
  "stations.searchResults": "نتائج البحث",
  "stations.searchResultsEmpty": "لم يتم العثور على نتائج.",
  "stations.searchResultsFound": "{count, plural, zero {لم يتم العثور على نتائج} one {تم العثور على نتيجة واحدة} two {تم العثور على نتيجتين} few {تم العثور على # نتائج} many {تم العثور على # نتيجة} other {تم العثور على # نتيجة}}",
  "stations.searchStationsDescription": "أدخل مدينة أو عنوان أو اسم مكان للعثور على محطات الطقس القريبة.",
  "stations.searchStationsHint": "استخدم شريط البحث أعلاه لاكتشاف محطات الطقس في أي مكان في العالم.",
  "stations.selectStationForComparison": "اختر محطة للمقارنة",
  "stations.stationAddedToFavorites": "تمت إضافة المحطة إلى المفضلة",
  "stations.stationCount": "{count, plural, zero {# محطة} one {# محطة} two {# محطتان} few {# محطات} many {# محطة} other {# محطة}}",
  "stations.stationInformation": "معلومات المحطة",
  "stations.stationName": "اسم المحطة",
  "stations.stationObservationsDescription": "عرض أحدث الرصدات من محطات الطقس",
  "stations.stationRemovedFromFavorites": "تمت إزالة المحطة من المفضلة",
  "stations.stationsNear": "محطات قريبة من {place}",
  "stations.stationType": "نوع المحطة",
  "stations.statusOffline": "غير متصل",
  "stations.statusOnline": "متصل",
  "stations.statusStale": "قديم",
  "stations.tryAnotherLocation": "لم نتمكن من العثور على محطات طقس قريبة من هذا الموقع. جرب البحث في منطقة مختلفة.",
  "stations.weatherStation": "محطة الطقس",
  "stations.weatherStationCount": "{count, plural, zero {# محطة طقس} one {# محطة طقس} two {# محطتا طقس} few {# محطات طقس} many {# محطة طقس} other {# محطة طقس}}",
  "stations.weatherStations": "محطات الطقس",
  "stations.welcomeConnectService": "هل تملك محطة أرصاد جوية؟ قم بربط خدمتك",
  "stations.welcomeSubtitle": "طقسك، كل شيء في مكان واحد",
  "thermostat.away": "خارج المنزل",
  "thermostat.boilerOn": "المرجل يعمل",
  "thermostat.hg": "الحماية من الصقيع",
  "thermostat.homeInformation": "معلومات المنزل",
  "thermostat.homeName": "اسم المنزل",
  "thermostat.manualBoost": "تعزيز يدوي",
  "thermostat.manualSetpointUntil": "نقطة الضبط اليدوية حتى",
  "thermostat.noThermostatYet": "ليس لديك منظم حرارة بعد.",
  "thermostat.relay": "المرحل",
  "thermostat.room": "الغرفة",
  "thermostat.rooms": "الغرف",
  "thermostat.smartThermostat": "منظم حرارة ذكي",
  "thermostat.smartValve": "صمام ذكي",
  "thermostat.whenBackHome": "متى ستعود إلى المنزل؟",
  "units.celsius": "سيلسيوس",
  "units.fahrenheit": "فهرنهايت",
  "units.inch": "بوصة",
  "units.inchOfMercury": "بوصة زئبق",
  "units.kelvin": "كلفن",
  "units.kilometerPerHour": "كيلومتر في الساعة",
  "units.knot": "عقدة",
  "units.meterPerSecond": "متر في الثانية",
  "units.milePerHour": "ميل في الساعة",
  "units.millibar": "مليبار",
  "units.millimeter": "مليمتر",
  "units.millimeterOfMercury": "مليمتر زئبق",
  "weatherConditions.blizzard": "عاصفة ثلجية",
  "weatherConditions.blowingDust": "غبار متطاير",
  "weatherConditions.blowingSnow": "ثلج متطاير",
  "weatherConditions.breezy": "نسيم",
  "weatherConditions.clear": "صافٍ",
  "weatherConditions.cloudy": "غائم",
  "weatherConditions.drizzle": "رذاذ",
  "weatherConditions.flurries": "تساقط ثلجي خفيف",
  "weatherConditions.foggy": "ضباب",
  "weatherConditions.freezingDrizzle": "رذاذ متجمد",
  "weatherConditions.freezingRain": "مطر متجمد",
  "weatherConditions.frigid": "برد قارس",
  "weatherConditions.hail": "بَرَد",
  "weatherConditions.haze": "سديم",
  "weatherConditions.heavyRain": "مطر غزير",
  "weatherConditions.heavySnow": "ثلوج كثيفة",
  "weatherConditions.hot": "حار",
  "weatherConditions.hurricane": "إعصار",
  "weatherConditions.isolatedThunderstorms": "عواصف رعدية منعزلة",
  "weatherConditions.mixedRainAndHail": "مطر وبَرَد",
  "weatherConditions.mostlyClear": "صافٍ في الغالب",
  "weatherConditions.mostlyCloudy": "غائم في الغالب",
  "weatherConditions.mostlySunny": "مشمس في الغالب",
  "weatherConditions.notAvailable": "الأحوال الجوية غير متوفرة",
  "weatherConditions.partlyCloudy": "غائم جزئياً",
  "weatherConditions.rain": "مطر",
  "weatherConditions.rainSleet": "مطر وحبيبات جليدية",
  "weatherConditions.rainSnow": "مطر وثلج",
  "weatherConditions.scatteredShowers": "زخات مطر متفرقة",
  "weatherConditions.scatteredSnowShowers": "زخات ثلجية متفرقة",
  "weatherConditions.scatteredThunderstorms": "عواصف رعدية متفرقة",
  "weatherConditions.showers": "زخات مطر",
  "weatherConditions.sleet": "حبيبات جليدية",
  "weatherConditions.smoke": "دخان",
  "weatherConditions.snow": "ثلج",
  "weatherConditions.snowShowers": "زخات ثلجية",
  "weatherConditions.strongStorms": "عواصف رعدية قوية",
  "weatherConditions.sunny": "مشمس",
  "weatherConditions.thunderstorms": "عواصف رعدية",
  "weatherConditions.tornado": "إعصار قمعي",
  "weatherConditions.tropicalStorm": "عاصفة استوائية",
  "weatherConditions.windy": "عاصف",
  "weatherConditions.wintryMix": "تساقطات شتوية مختلطة",
  "weatherMap.legendHeavy": "غزير",
  "weatherMap.legendLight": "خفيف",
  "weatherMap.legendLightningHelp": "يوضح اللون عمر كل صاعقة خلال آخر {minutes} دقيقة — الأحدث باللون الأبيض والأقدم باللون الأحمر الداكن.",
  "weatherMap.legendNewest": "الأحدث",
  "weatherMap.legendOldest": "الأقدم",
  "weatherMap.legendStationsHelp": "يعكس لون العلامة قيمة المقياس المحدد.",
  "weatherMap.lightningDataAttribution": "بيانات البرق: Blitzortung.org",
  "weatherMap.lightningStrikes": "ضربات البرق",
  "weatherMap.lightningStrikesDescription": "عرض ضربات البرق في الوقت الفعلي على الخريطة",
  "weatherMap.mapLayers": "طبقات الخريطة",
  "weatherMap.mapLegend": "مفتاح الخريطة",
  "weatherMap.radarDataAttribution": "بيانات الرادار: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.rainRadar": "رادار المطر",
  "weatherMap.rainRadarDescription": "عرض طبقة رادار المطر على الخريطة",
  "weatherMap.weatherflowNCRain": "NC Rain (مطر Nearcast)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain هو مصدر بيانات إضافي يتم توفيره عبر نظام Tempest للطقس، مدعوم بتقنية Nearcast. بيانات NC Rain هي تقدير لمتوسط تراكم هطول الأمطار حول جهاز Tempest الخاص بك على مستوى الحي",
  "weatherMap.weatherMap": "خريطة الطقس",
  "weatherMap.weatherMapMetaDescription": "SmartMixin يوفر خرائط تفاعلية للطقس والرادار لظروف الطقس في جميع أنحاء العالم.",
  "weatherWarnings.activeNow": "سارية الآن",
  "weatherWarnings.agencyMessage": "رسالة هيئة الأرصاد",
  "weatherWarnings.areaCovered": "المنطقة المشمولة",
  "weatherWarnings.areaThisLocation": "{area} (هذا الموقع)",
  "weatherWarnings.areaYourStation": "{area} (محطة الطقس الخاصة بك)",
  "weatherWarnings.crumb": "التحذيرات الرسمية",
  "weatherWarnings.emptyBody": "لا يوجد لدى هيئة الأرصاد الوطنية أي تحذير ساري المفعول لهذا المكان. نتحقق مجددًا كل بضع دقائق.",
  "weatherWarnings.emptyTitle": "لا توجد تحذيرات رسمية",
  "weatherWarnings.ended": "انتهى",
  "weatherWarnings.endedAt": "انتهى هذا التحذير {time}.",
  "weatherWarnings.errorBody": "تحقق من اتصالك. نعيد المحاولة كل بضع دقائق.",
  "weatherWarnings.errorTitle": "تعذّر تحميل التحذيرات الرسمية",
  "weatherWarnings.fromTime": "من {time}",
  "weatherWarnings.hazardAirQuality": "جودة الهواء",
  "weatherWarnings.hazardAvalanche": "انهيارات ثلجية",
  "weatherWarnings.hazardCoastalEvent": "مخاطر ساحلية",
  "weatherWarnings.hazardFlood": "فيضانات",
  "weatherWarnings.hazardFog": "ضباب",
  "weatherWarnings.hazardForestFire": "حرائق الغابات",
  "weatherWarnings.hazardHighTemperature": "درجات حرارة مرتفعة",
  "weatherWarnings.hazardLowTemperature": "درجات حرارة منخفضة",
  "weatherWarnings.hazardOther": "خطر آخر",
  "weatherWarnings.hazardRain": "مطر",
  "weatherWarnings.hazardSnowIce": "ثلوج وجليد",
  "weatherWarnings.hazardThunderstorm": "عواصف رعدية",
  "weatherWarnings.hazardUv": "الأشعة فوق البنفسجية",
  "weatherWarnings.hazardWind": "الرياح",
  "weatherWarnings.hideHazards": "إخفاء المخاطر",
  "weatherWarnings.issuedBy": "صادر عن {sender}",
  "weatherWarnings.lastUpdate": "آخر تحديث: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {خريطة المنطقة المشمولة: {area}.} other {خريطة المناطق المشمولة (#). المنطقة المميزة: {area}.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {الخريطة غير متاحة. المنطقة مذكورة أدناه.} other {الخريطة غير متاحة. قائمة المناطق (#) أدناه.}}",
  "weatherWarnings.moreHazards": "+ {count} أخرى: {hazards}",
  "weatherWarnings.notInLanguage": "غير متاح باللغة {language}. يُعرض كما نشرته هيئة الأرصاد.",
  "weatherWarnings.openOn": "فتح على {site}",
  "weatherWarnings.otherAreas": "{count, plural, zero {+ # منطقة أخرى} one {+ منطقة أخرى واحدة} two {+ منطقتان أخريان} few {+ # مناطق أخرى} many {+ # منطقة أخرى} other {+ # منطقة أخرى}}",
  "weatherWarnings.severityExtreme": "بالغ الشدة",
  "weatherWarnings.severityFrom": "{severity} من {time}",
  "weatherWarnings.severityMinor": "طفيف",
  "weatherWarnings.severityModerate": "معتدل",
  "weatherWarnings.severityNow": "{severity} الآن",
  "weatherWarnings.severitySevere": "شديد",
  "weatherWarnings.severityUntil": "{severity} حتى {time}",
  "weatherWarnings.showAllAreas": "{count, plural, zero {عرض # منطقة} one {عرض منطقة واحدة} two {عرض المنطقتين} few {عرض كل المناطق ({count})} many {عرض كل المناطق ({count})} other {عرض كل المناطق ({count})}}",
  "weatherWarnings.showHazards": "إظهار المخاطر",
  "weatherWarnings.showPeriods": "{count, plural, zero {عرض # فترة} one {عرض فترة واحدة} two {عرض الفترتين} few {عرض كل الفترات (#)} many {عرض كل الفترات (#)} other {عرض كل الفترات (#)}}",
  "weatherWarnings.source": "المصدر: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}، ثم {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, zero {# تحذير جوي رسمي} one {تحذير جوي رسمي واحد} two {تحذيران جويان رسميان} few {# تحذيرات جوية رسمية} many {# تحذيرًا جويًا رسميًا} other {# تحذير جوي رسمي}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "التحذيرات الجوية الرسمية",
  "weatherWarnings.todayAt": "اليوم الساعة {time}",
  "weatherWarnings.tomorrow": "غدًا",
  "weatherWarnings.tomorrowAt": "غدًا الساعة {time}",
  "weatherWarnings.upcoming": "قادمة",
  "weatherWarnings.viewAll": "كل التحذيرات الرسمية",
  "weatherWarnings.whatToDo": "ما يجب فعله"
}
